import { unref as _unref, renderSlot as _renderSlot, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "text-sm text-gray-700" }
const _hoisted_2 = { class: "font-semibold" }
const _hoisted_3 = { class: "flex flex-col justify-between h-full" }
const _hoisted_4 = { class: "px-6 md:px-8 pt-6 pb-20" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { class: "max-w-[1180px]" }
const _hoisted_7 = { class: "grid grid-cols-1 gap-5 sm:grid-cols-3" }
const _hoisted_8 = { class: "rounded-lg bg-white px-4 py-5 shadow sm:p-6" }
const _hoisted_9 = { class: "mt-1 text-3xl font-semibold tracking-tight text-gray-900" }
const _hoisted_10 = { class: "mt-2 text-sm text-gray-500" }
const _hoisted_11 = { class: "font-medium" }
const _hoisted_12 = { class: "text-sm text-gray-500" }
const _hoisted_13 = { class: "font-medium" }
const _hoisted_14 = { class: "mt-1 text-3xl font-semibold tracking-tight text-gray-900" }
const _hoisted_15 = { class: "mt-2 text-sm text-gray-500" }
const _hoisted_16 = { class: "font-medium" }
const _hoisted_17 = { class: "text-sm text-gray-500" }
const _hoisted_18 = { class: "font-medium" }
const _hoisted_19 = { class: "rounded-lg bg-white px-4 py-5 shadow sm:p-6" }
const _hoisted_20 = { class: "mt-1 text-3xl font-semibold tracking-tight text-gray-900" }
const _hoisted_21 = { key: 1 }
const _hoisted_22 = {
  key: 1,
  class: "overflow-x-auto p-2 -m-2"
}
const _hoisted_23 = { class: "flex items-center justify-between w-full" }
const _hoisted_24 = { class: "flex items-center justify-between w-full" }
const _hoisted_25 = { class: "text-gray-900 font-medium break-words" }
const _hoisted_26 = { key: 0 }
const _hoisted_27 = { key: 1 }
const _hoisted_28 = { key: 2 }
const _hoisted_29 = { class: "mt-10 mb-6" }
const _hoisted_30 = { class: "space-y-1 flex items-center" }
const _hoisted_31 = {
  key: 0,
  class: "text-sm font-semibold bg-gray-200 rounded-md px-1 py-0.5 ml-3 h-6"
}
const _hoisted_32 = { class: "overflow-x-auto p-2 -m-2" }
const _hoisted_33 = { class: "text-gray-900 font-medium truncate" }
const _hoisted_34 = { class: "break-words" }
const _hoisted_35 = { class: "max-w-[1040px]" }
const _hoisted_36 = {
  key: 0,
  class: "my-4"
}
const _hoisted_37 = {
  key: 1,
  class: "mt-4 -mb-6"
}
const _hoisted_38 = {
  key: 2,
  class: "flex justify-end items-center w-full"
}
const _hoisted_39 = {
  key: 0,
  class: "italic mr-4 text-red-600"
}
const _hoisted_40 = {
  key: 1,
  class: "italic mr-4"
}
const _hoisted_41 = { class: "max-w-[1180px]" }
const _hoisted_42 = { class: "mb-8" }
const _hoisted_43 = { class: "sm:hidden" }
const _hoisted_44 = { class: "hidden sm:block" }
const _hoisted_45 = {
  class: "flex flex-wrap",
  "aria-label": "Tabs"
}
const _hoisted_46 = ["aria-current", "onClick"]
const _hoisted_47 = { class: "text-sm font-semibold bg-gray-200 rounded-md px-1 py-0.5 ml-2 h-6" }
const _hoisted_48 = { key: 0 }
const _hoisted_49 = {
  key: 0,
  class: "-mt-8 mb-6 pt-2 w-full sm:w-96 flex items-end gap-3"
}
const _hoisted_50 = { class: "flex-1 min-w-0" }
const _hoisted_51 = { key: 0 }
const _hoisted_52 = { class: "overflow-x-auto p-2 -m-2" }
const _hoisted_53 = { key: 0 }
const _hoisted_54 = { class: "flex flex-wrap gap-2" }
const _hoisted_55 = { class: "flex flex-col gap-2" }
const _hoisted_56 = { class: "border-b border-gray-200 px-3 py-4 sm:px-4" }
const _hoisted_57 = { class: "flex flex-wrap items-center justify-between" }
const _hoisted_58 = { class: "w-2/3" }
const _hoisted_59 = { class: "text-base font-semibold leading-4 text-gray-900 truncate" }
const _hoisted_60 = { class: "mt-1 text-sm text-gray-500" }
const _hoisted_61 = { class: "w-1/3 flex-shrink-0 text-right" }
const _hoisted_62 = { class: "text-sm font-semibold leading-4 text-gray-900" }
const _hoisted_63 = { class: "mt-1 text-xs text-gray-500" }
const _hoisted_64 = { class: "px-3 sm:px-3 flex flex-col gap-2" }
const _hoisted_65 = {
  key: 0,
  class: "ml-9 my-1 underline underline-offset-8"
}
const _hoisted_66 = { class: "font-bold" }
const _hoisted_67 = { class: "flex flex-col gap-2 py-2" }
const _hoisted_68 = { class: "flex-shrink-0 w-6 text-right font-medium text-gray-900 font-mono" }
const _hoisted_69 = { class: "flex-grow" }
const _hoisted_70 = { class: "font-medium break-words" }
const _hoisted_71 = {
  key: 0,
  class: "text-xs text-gray-500 break-words"
}
const _hoisted_72 = { class: "px-3 py-4 sm:px-4" }
const _hoisted_73 = { key: 0 }
const _hoisted_74 = { class: "flex flex-wrap gap-2" }
const _hoisted_75 = { class: "flex flex-col gap-2" }
const _hoisted_76 = { class: "border-b border-gray-200 px-3 py-4 sm:px-4" }
const _hoisted_77 = { class: "flex flex-wrap items-center justify-between" }
const _hoisted_78 = { class: "w-2/3" }
const _hoisted_79 = { class: "text-base font-semibold leading-4 text-gray-900 truncate" }
const _hoisted_80 = { class: "mt-1 text-sm text-gray-500" }
const _hoisted_81 = { class: "w-1/3 flex-shrink-0 text-right" }
const _hoisted_82 = { class: "text-sm font-semibold leading-4 text-gray-900" }
const _hoisted_83 = { class: "mt-1 text-xs text-gray-500" }
const _hoisted_84 = { class: "px-3 sm:px-3 flex flex-col gap-2" }
const _hoisted_85 = {
  key: 0,
  class: "ml-9 my-1 underline underline-offset-8"
}
const _hoisted_86 = { class: "font-bold" }
const _hoisted_87 = { class: "flex flex-col gap-2 py-2" }
const _hoisted_88 = { class: "flex-shrink-0 w-6 text-right font-medium text-gray-900 font-mono" }
const _hoisted_89 = { class: "flex-grow" }
const _hoisted_90 = { class: "font-medium break-words" }
const _hoisted_91 = {
  key: 0,
  class: "text-xs text-gray-500 break-words"
}
const _hoisted_92 = { class: "px-3 py-4 sm:px-4" }
const _hoisted_93 = { key: 0 }
const _hoisted_94 = { class: "overflow-x-auto p-2 -m-2" }
const _hoisted_95 = {
  key: 1,
  class: "max-w-[1180px]"
}
const _hoisted_96 = { class: "overflow-x-auto p-2 -m-2" }
const _hoisted_97 = { class: "truncate" }
const _hoisted_98 = { class: "min-w-0" }
const _hoisted_99 = { class: "text-gray-900 font-medium truncate" }
const _hoisted_100 = { class: "text-xs text-gray-500 truncate" }
const _hoisted_101 = { class: "truncate" }
const _hoisted_102 = { class: "min-w-0" }
const _hoisted_103 = { class: "truncate" }
const _hoisted_104 = {
  key: 0,
  class: "text-xs text-gray-500 truncate"
}
const _hoisted_105 = { class: "flex justify-end items-center gap-2" }
const _hoisted_106 = ["href"]
const _hoisted_107 = {
  key: 0,
  class: "text-sm text-red-600 mt-2"
}
const _hoisted_108 = { class: "max-w-[1180px]" }
const _hoisted_109 = { class: "mb-8" }
const _hoisted_110 = { class: "sm:hidden" }
const _hoisted_111 = { class: "hidden sm:block" }
const _hoisted_112 = {
  class: "flex flex-wrap",
  "aria-label": "Tabs"
}
const _hoisted_113 = ["aria-current", "onClick"]
const _hoisted_114 = { class: "text-sm font-semibold bg-gray-200 rounded-md px-1 py-0.5 ml-2 h-6" }
const _hoisted_115 = { key: 0 }
const _hoisted_116 = { key: 0 }
const _hoisted_117 = { class: "overflow-x-auto p-2 -m-2" }
const _hoisted_118 = { key: 0 }
const _hoisted_119 = { class: "overflow-x-auto p-2 -m-2" }
const _hoisted_120 = { key: 0 }
const _hoisted_121 = { class: "overflow-x-auto p-2 -m-2" }
const _hoisted_122 = { key: 0 }
const _hoisted_123 = { class: "overflow-x-auto p-2 -m-2" }
const _hoisted_124 = { class: "max-w-[1180px]" }
const _hoisted_125 = { class: "truncate" }
const _hoisted_126 = { class: "max-w-[1180px]" }
const _hoisted_127 = { key: 0 }
const _hoisted_128 = { class: "overflow-x-auto p-2 -m-2" }
const _hoisted_129 = { class: "text-gray-900 font-medium truncate" }
const _hoisted_130 = { class: "break-words" }
const _hoisted_131 = { class: "max-w-[1180px]" }
const _hoisted_132 = {
  key: 0,
  class: "overflow-x-auto p-2 -m-2"
}
const _hoisted_133 = { class: "flex justify-end" }
const _hoisted_134 = { class: "truncate" }
const _hoisted_135 = { class: "truncate" }
const _hoisted_136 = {
  key: 2,
  class: "max-w-[1180px]"
}
const _hoisted_137 = {
  key: 0,
  class: "overflow-x-auto p-2 -m-2"
}
const _hoisted_138 = { class: "flex justify-end" }
const _hoisted_139 = { class: "truncate" }
const _hoisted_140 = { class: "truncate" }
const _hoisted_141 = { class: "truncate" }
const _hoisted_142 = { key: 0 }
const _hoisted_143 = {
  key: 1,
  class: "italic"
}
const _hoisted_144 = { class: "flex justify-end" }
const _hoisted_145 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_146 = ["href"]

import { ArrowDownTrayIcon, ExclamationTriangleIcon } from '@heroicons/vue/20/solid'
import TimeAgo from 'javascript-time-ago'
import en from 'javascript-time-ago/locale/en'
import _ from 'lodash'
import { computed, onBeforeUnmount, ref, watch } from 'vue'
import { onBeforeRouteUpdate, useRoute, useRouter } from 'vue-router'
import { useStore } from 'vuex'

import BottleRow from '@/components/neue/BottleRow'
import ListFilterEditor from '@/components/neue/ListFilterEditor.vue'
import SettingsSection from '@/components/neue/SettingsSection.vue'
import TablistGrid from '@/components/neue/TablistGrid.vue'
import { useRouteTabs } from '@/composables/useRouteTabs'
import { useToast } from '@/composables/useToast'
import { listPath, SMART_LISTS_TAB } from '@/config/listSections'
import { serverDayToDateObject } from '@/helpers/dates'
import {
  filterMissingValue,
  filterOptions,
  localFilterToServer,
  mergeFilter,
  newListAttributes,
  serverFilterToLocal
} from '@/helpers/filters'
import { toastPlanLimit } from '@/helpers/planLimits'
import { buildTierListGuard } from '@/router/tierListGuard'
import privilegeService from '@/services/privilege.service'
import api from '@/store/api'
import { mapRelationship, mapRelationships, mapType } from '@/store/mappers'

const pageSize = 20


export default {
  __name: 'AudienceNeue',
  props: {
  audienceId: { type: String, default: null },
  basePath: { type: String, default: null },
  onlyTabs: { type: Array, default: null },
  leadTab: { type: Object, default: null }
},
  setup(__props) {

const props = __props

TimeAgo.addLocale(en)
const timeAgo = new TimeAgo('en-CA')
const route = useRoute()
const router = useRouter()
const store = useStore()
const tierListGuard = buildTierListGuard(() => store.state.loggedInUser)

onBeforeRouteUpdate((to, from) => (props.audienceId || to.params.id === from.params.id ? true : tierListGuard(to)))

const audienceId = computed(() => String(props.audienceId ?? route.params.id))

const canWriteCustomers = computed(() => privilegeService.canAccessResourceAction('customers', null, 'update'))
const canCreateAutomations = computed(() => privilegeService.canAccessResourceAction('automation', null, 'create'))
const canCreateReports = computed(() => privilegeService.canAccessResourceAction('reports', null, 'create'))
const canUpdateOrders = computed(() => privilegeService.canAccessResourceAction('orders', null, 'update'))

const dropsCols = [{ width: 'minmax(120px, 2fr)' }, { width: 'minmax(90px, 1fr)' }, { width: 'minmax(80px, 1fr)' }]

const cartSubscribersCols = [
  { width: 'minmax(140px, 2fr)' },
  { width: 'minmax(140px, 3fr)' },
  { width: 'minmax(100px, 1fr)' }
]

const automationsCols = [
  { width: 'minmax(140px, 2fr)' },
  { width: 'minmax(120px, 2fr)' },
  { width: 'minmax(140px, 2fr)' },
  { width: '140px' }
]

const reportsCols = [
  { width: 'minmax(140px, 2fr)' },
  { width: 'minmax(140px, 2fr)' },
  { width: 'minmax(140px, 2fr)' },
  { width: '130px' }
]

const uberDeliveriesCols = [
  { width: 'minmax(100px, 1fr)' },
  { width: 'minmax(160px, 2fr)' },
  { width: 'minmax(160px, 2fr)' },
  { width: 'minmax(140px, 2fr)' },
  { width: 'minmax(160px, 2fr)' }
]

const freshnessCutoff = ref(Date.now() - 5000)
const cachebuster = ref(0)
const cachebusterTimer = setInterval(() => cachebuster.value++, 60000)
onBeforeUnmount(() => clearInterval(cachebusterTimer))
const reportsModalOpen = ref(false)
const sort = ref('sort_by_field=bottle_payments.created_at&sort_direction=asc')

const audience = computed(() => mapRelationship({ type: 'audience', id: audienceId.value }))
const detail = computed(() => mapRelationship(audience.value?.relationships.audience_detail.data))
const activityDetail = computed(() => mapRelationship(audience.value?.relationships.audience_activity_detail.data))
const rootAudience = computed(() => mapRelationship(audience.value?.relationships.root_audience.data))
const isDateAudience = computed(() => Boolean(audience.value?.attributes.date))
const backLink = computed(() => {
  if (!audience.value) return undefined
  if (isDateAudience.value) return { name: 'Orders', link: '/orders' }
  return { name: SMART_LISTS_TAB.name, link: listPath(SMART_LISTS_TAB.id) }
})
const cartSubscribers = computed(() => mapRelationships(activityDetail.value?.relationships.cart_subscribers?.data))
const hideNumbers = computed(() => store.state.hideNumbers)

const drops = ref([])

const paid = ref([])
const unpacked = ref([])
const packed = ref([])
const arrival = ref([])
const carts = ref([])
const cancelled = ref([])
const attention = ref([])
const skipped = ref([])
const pending = ref([])
const products = ref([])
const productVariants = ref({})
const loadingVariants = ref({})
const packingBottle = ref({}) // { bottleId: true } tracks which bottles are being marked packed/unpacked
const recentlyCancelledOrUncancelledTabKey = ref(null) // reload this tab when leaving after cancel/uncancel
const pairs = ref([])
const pairsIncludedLookup = ref([])
const uberDeliveryIds = ref([])
const cancellingDelivery = ref({}) // { uberDeliveryId: true } tracks which couriers are being cancelled
const deliveryError = ref('')

const loading = ref({})

const pendingName = ref(null)
let keepPendingName = false
const nameFieldValue = computed(() => pendingName.value ?? audience.value?.attributes.audience_name ?? '')
const nameChanged = computed(
  () => pendingName.value !== null && pendingName.value.trim() !== audience.value?.attributes.audience_name
)
const saveType = type => (nameFieldValue.value.trim() ? type : 'inactive')
const updateTarget = computed(() => (audience.value?.attributes.is_root ? audience.value : rootAudience.value))

const pagination = ref({})

const resetValues = () => {
  loading.value = {
    audience: true,
    detail: true,
    drops: true,
    paid: true,
    carts: true,
    cancelled: true,
    attention: true,
    products: true,
    pairs: true,
    automations: true,
    reports: true,
    packed: true,
    unpacked: true,
    arrival: true,
    uberDeliveries: true
  }
  pagination.value = {
    pairs: { page: 0, size: null, cursor: null },
    paid: { page: 0, size: null, cursor: null },
    unpacked: { page: 0, size: null, cursor: null },
    packed: { page: 0, size: null, cursor: null },
    arrival: { page: 0, size: null, cursor: null },
    carts: { page: 0, size: null, cursor: null },
    cancelled: { page: 0, size: null, cursor: null },
    attention: { page: 0, size: null, cursor: null },
    skipped: { page: 0, size: null, cursor: null },
    pending: { page: 0, size: null, cursor: null }
  }
  drops.value = []
  paid.value = []
  unpacked.value = []
  packed.value = []
  arrival.value = []
  carts.value = []
  cancelled.value = []
  attention.value = []
  skipped.value = []
  pending.value = []
  products.value = []
  productVariants.value = {}
  loadingVariants.value = {}
  packingBottle.value = {}
  recentlyCancelledOrUncancelledTabKey.value = null
  pairs.value = []
  pairsIncludedLookup.value = []
  uberDeliveryIds.value = []
  cancellingDelivery.value = {}
  deliveryError.value = ''
}
resetValues()

const controller = ref(new AbortController())

const loadList = id => {
  if (!keepPendingName) pendingName.value = null
  keepPendingName = false
  freshnessCutoff.value = Date.now() - 5000
  resetValues()
  controller.value.abort()
  controller.value = new AbortController()

  api
    .call(
      'GET',
      `audiences/${id}?included=${[
        'filter_groups',
        'filter_groups.filters',
        'filter_groups.filters.filter_field_values'
      ].join(',')}`,
      {},
      { abortController: controller.value, quietAbort: true }
    )
    .then(() => {
      loading.value.audience = false

      if (isDateAudience.value) {
        api
          .call(
            'GET',
            `audiences/${id}?included=audience_detail,audience_activity_detail`,
            {},
            { abortController: controller.value, quietAbort: true }
          )
          .then(() => {
            loading.value.detail = false
          })
      }
    })

  api
    .call(
      'GET',
      `audiences/${id}/bottle_cycles?included=bottle_cycle_detail,fulfillment_availabilities,audiences`,
      {},
      { abortController: controller.value, quietAbort: true }
    )
    .then(x => {
      drops.value = x.data.data
      loading.value.drops = false
    })
    .then(() => {
      if (isDateAudience.value && (!drops.value.length || drops.value.some(x => !x.attributes.open_for_ordering))) {
        api
          .call(
            'GET',
            `audiences/${id}?included=audience_activity_detail.cart_subscribers`,
            {},
            { abortController: controller.value, quietAbort: true }
          )
          .then(() => {
            loading.value.cartSubscribers = false
          })
      }
    })

  loadUberDeliveries(id)
}

const loadPanels = id => {
  api
    .call(
      'GET',
      `audiences/${id}/orders_optimized?offset=${pageSize}&cursor=0&${sort.value}`,
      {},
      { abortController: controller.value, quietAbort: true }
    )
    .then(x => {
      paid.value.push(x.data.data)
      pagination.value.paid.cursor = x.data.next_cursor
      pagination.value.paid.size = x.data.total_records
      loading.value.paid = false
    })
  if (isDateAudience.value) {
    api
      .call(
        'GET',
        `audiences/${id}/orders_optimized?offset=${pageSize}&cursor=0&${sort.value}&filter=packed`,
        {},
        { abortController: controller.value, quietAbort: true }
      )
      .then(x => {
        packed.value.push(x.data.data)
        pagination.value.packed.cursor = x.data.next_cursor
        pagination.value.packed.size = x.data.total_records
        loading.value.packed = false
      })
    api
      .call(
        'GET',
        `audiences/${id}/orders_optimized?offset=${pageSize}&cursor=0&${sort.value}&filter=not_produced`,
        {},
        { abortController: controller.value, quietAbort: true }
      )
      .then(x => {
        unpacked.value.push(x.data.data)
        pagination.value.unpacked.cursor = x.data.next_cursor
        pagination.value.unpacked.size = x.data.total_records
        loading.value.unpacked = false
      })
    api
      .call(
        'GET',
        `audiences/${id}/orders_optimized?offset=${pageSize}&cursor=0&${sort.value}&filter=cart_item_fulfillment_date`,
        {},
        { abortController: controller.value, quietAbort: true }
      )
      .then(x => {
        arrival.value.push(x.data.data)
        pagination.value.arrival.cursor = x.data.next_cursor
        pagination.value.arrival.size = x.data.total_records
        loading.value.arrival = false
      })
  }
  api
    .call(
      'GET',
      `audiences/${id}/cancelled_orders?offset=${pageSize}&cursor=0`,
      {},
      { abortController: controller.value, quietAbort: true }
    )
    .then(x => {
      cancelled.value.push(x.data.data)
      pagination.value.cancelled.cursor = x.data.next_cursor
      pagination.value.cancelled.size = x.data.total_records
      loading.value.cancelled = false
    })

  api
    .call(
      'GET',
      `audiences/${id}/carts_optimized?offset=${pageSize}&cursor=0`,
      {},
      { abortController: controller.value, quietAbort: true, receive: true }
    )
    .then(x => {
      carts.value.push(x.data.data)
      pagination.value.carts.cursor = x.data.next_cursor
      pagination.value.carts.size = x.data.total_records
      loading.value.carts = false
    })
  api
    .call(
      'GET',
      `audiences/${id}/carts_that_need_attention_optimized?offset=${pageSize}&cursor=0`,
      {},
      { abortController: controller.value, quietAbort: true, receive: true }
    )
    .then(x => {
      attention.value.push(x.data.data)
      pagination.value.attention.cursor = x.data.next_cursor
      pagination.value.attention.size = x.data.total_records
      loading.value.attention = false
    })
  api
    .call(
      'GET',
      `audiences/${id}/skipped?offset=${pageSize}&cursor=0`,
      {},
      { abortController: controller.value, quietAbort: true }
    )
    .then(x => {
      skipped.value.push(x.data.data)
      pagination.value.skipped.cursor = x.data.next_cursor
      pagination.value.skipped.size = x.data.total_records
      loading.value.skipped = false
    })
  api
    .call(
      'GET',
      `audiences/${id}/pending?offset=${pageSize}&cursor=0`,
      {},
      { abortController: controller.value, quietAbort: true }
    )
    .then(x => {
      pending.value.push(x.data.data)
      pagination.value.pending.cursor = x.data.next_cursor
      pagination.value.pending.size = x.data.total_records
      loading.value.pending = false
    })

  api
    .call(
      'GET',
      `audiences/${id}/order_product_details_optimized`,
      {},
      { abortController: controller.value, quietAbort: true, receive: false }
    )
    .then(x => {
      products.value = x.data.products ?? []
      productVariants.value = x.data.variants_by_product ?? {}
      loading.value.products = false
    })
    .catch(() => {
      loading.value.products = false
    })

  api
    .call(
      'GET',
      `audiences/${id}/conversation_user_pairs_optimized?offset=${pageSize}&cursor=0`,
      {},
      { abortController: controller.value, quietAbort: true, receive: false }
    )
    .then(x => {
      addPairsPage(x.data)
      pagination.value.pairs.cursor = x.data.next_cursor
      pagination.value.pairs.size = x.data.total_records
      loading.value.pairs = false
    })

  Promise.all([
    api.call(
      'GET',
      'message_automations?included=automation_scheduler',
      {},
      { abortController: controller.value, quietAbort: true }
    ),
    api.call(
      'GET',
      'bottle_reminder_automations?included=bottle_cycle,automation_scheduler,audiences',
      {},
      { abortController: controller.value, quietAbort: true }
    ),
    api.call('GET', 'membership_passes?included=none', {}, { abortController: controller.value, quietAbort: true })
  ]).then(() => {
    loading.value.automations = false
  })

  api
    .call('GET', `audiences/${id}/data_downloads`, {}, { abortController: controller.value, quietAbort: true })
    .then(() => {
      loading.value.reports = false
    })
}

const loadUberDeliveries = id =>
  api
    .call('GET', `audiences/${id}/uber_deliveries`, {}, { abortController: controller.value, quietAbort: true })
    .then(x => {
      uberDeliveryIds.value = x.data.data.map(delivery => delivery.id)
      loading.value.uberDeliveries = false
    })

const reloadOrders = () => {
  loading.value.paid = true
  loading.value.unpacked = true
  loading.value.packed = true
  loading.value.arrival = true

  // Reset page arrays and pagination state
  paid.value = []
  unpacked.value = []
  packed.value = []
  arrival.value = []
  pagination.value.paid = { page: 0, size: null, cursor: null }
  pagination.value.unpacked = { page: 0, size: null, cursor: null }
  pagination.value.packed = { page: 0, size: null, cursor: null }
  pagination.value.arrival = { page: 0, size: null, cursor: null }

  api
    .call(
      'GET',
      `audiences/${audienceId.value}/orders_optimized?offset=${pageSize}&cursor=0&${sort.value}`,
      {},
      { abortController: controller.value, quietAbort: true }
    )
    .then(x => {
      paid.value.push(x.data.data)
      pagination.value.paid.cursor = x.data.next_cursor
      pagination.value.paid.size = x.data.total_records
      loading.value.paid = false
    })
  api
    .call(
      'GET',
      `audiences/${audienceId.value}/orders_optimized?offset=${pageSize}&cursor=0&${sort.value}&filter=not_produced`,
      {},
      { abortController: controller.value, quietAbort: true }
    )
    .then(x => {
      unpacked.value.push(x.data.data)
      pagination.value.unpacked.cursor = x.data.next_cursor
      pagination.value.unpacked.size = x.data.total_records
      loading.value.unpacked = false
    })
  api
    .call(
      'GET',
      `audiences/${audienceId.value}/orders_optimized?offset=${pageSize}&cursor=0&${sort.value}&filter=packed`,
      {},
      { abortController: controller.value, quietAbort: true }
    )
    .then(x => {
      packed.value.push(x.data.data)
      pagination.value.packed.cursor = x.data.next_cursor
      pagination.value.packed.size = x.data.total_records
      loading.value.packed = false
    })
  api
    .call(
      'GET',
      `audiences/${audienceId.value}/orders_optimized?offset=${pageSize}&cursor=0&${sort.value}&filter=cart_item_fulfillment_date`,
      {},
      { abortController: controller.value, quietAbort: true }
    )
    .then(x => {
      arrival.value.push(x.data.data)
      pagination.value.arrival.cursor = x.data.next_cursor
      pagination.value.arrival.size = x.data.total_records
      loading.value.arrival = false
    })
}

const pairsPrev = ret => {
  pagination.value.pairs.page--
  ret()
}

const pairsNext = ret => {
  if (pairs.value.length <= pagination.value.pairs.page + 1 && pagination.value.pairs.cursor) {
    loading.value.pairs = true
    api
      .call(
        'GET',
        `audiences/${audienceId.value}/conversation_user_pairs_optimized?offset=${pageSize}&cursor=${pagination.value.pairs.cursor}`,
        {},
        { receive: false }
      )
      .then(x => {
        addPairsPage(x.data)
        pagination.value.pairs.cursor = x.data.next_cursor
        pagination.value.pairs.page++
        loading.value.pairs = false
        ret()
      })
  } else {
    pagination.value.pairs.page++
    ret()
  }
}

const bottlesPrev = (tab, ret) => {
  const localName = {
    'Unpaid carts': 'carts',
    'Cancelled orders': 'cancelled',
    'Carts that need attention': 'attention',
    Skipped: 'skipped',
    'Will be charged': 'pending'
  }[tab]
  pagination.value[localName].page--
  ret()
}

const bottlesNext = (tab, ret) => {
  const { localValue, localName, serverName } = {
    'Unpaid carts': {
      localValue: carts,
      localName: 'carts',
      serverName: 'carts_optimized'
    },
    'Cancelled orders': {
      localValue: cancelled,
      localName: 'cancelled',
      serverName: 'cancelled_orders'
    },
    'Carts that need attention': {
      localValue: attention,
      localName: 'attention',
      serverName: 'carts_that_need_attention_optimized'
    },
    Skipped: {
      localValue: skipped,
      localName: 'skipped',
      serverName: 'skipped'
    },
    'Will be charged': {
      localValue: pending,
      localName: 'pending',
      serverName: 'pending'
    }
  }[tab]

  if (localValue.value.length <= pagination.value[localName].page + 1 && pagination.value[localName].cursor) {
    loading.value[localName] = true
    api
      .call(
        'GET',
        `audiences/${audienceId.value}/${serverName}?offset=${pageSize}&cursor=${pagination.value[localName].cursor}`
      )
      .then(x => {
        localValue.value.push(x.data.data)
        pagination.value[localName].cursor = x.data.next_cursor
        pagination.value[localName].page++
        loading.value[localName] = false
        ret()
      })
  } else {
    pagination.value[localName].page++
    ret()
  }
}

const ordersPrev = (tab, ret) => {
  const localName = {
    'All orders': 'paid',
    'Unpacked orders': 'unpacked',
    'Packed orders': 'packed',
    'Orders with arrival day': 'arrival'
  }[tab]
  pagination.value[localName].page--
  ret()
}

const ordersNext = (tab, ret) => {
  const { localValue, localName, filter } = {
    'All orders': {
      localValue: paid,
      localName: 'paid',
      filter: null
    },
    'Unpacked orders': {
      localValue: unpacked,
      localName: 'unpacked',
      filter: 'not_produced'
    },
    'Packed orders': {
      localValue: packed,
      localName: 'packed',
      filter: 'packed'
    },
    'Orders with arrival day': {
      localValue: arrival,
      localName: 'arrival',
      filter: 'cart_item_fulfillment_date'
    }
  }[tab]

  if (localValue.value.length <= pagination.value[localName].page + 1 && pagination.value[localName].cursor) {
    loading.value[localName] = true
    const filterParam = filter ? `&filter=${filter}` : ''
    api
      .call(
        'GET',
        `audiences/${audienceId.value}/orders_optimized?offset=${pageSize}&cursor=${pagination.value[localName].cursor}&${sort.value}${filterParam}`
      )
      .then(x => {
        localValue.value.push(x.data.data)
        pagination.value[localName].cursor = x.data.next_cursor
        pagination.value[localName].page++
        loading.value[localName] = false
        ret()
      })
  } else {
    pagination.value[localName].page++
    ret()
  }
}

const ordersTabs = computed(() => {
  const rels = audience.value?.relationships ?? {}
  if ('bottle_cycle' in rels) {
    return ['All orders', 'Cancelled orders']
  } else if ('fulfillment_slot' in rels) {
    return ['All orders', 'Unpacked orders', 'Packed orders', 'Orders with arrival day', 'Cancelled orders']
  } else {
    return ['All orders', 'Cancelled orders']
  }
})
const ordersTab = ref('All orders')

const cartsTabs = computed(() => {
  const rels = audience.value?.relationships ?? {}
  if ('bottle_cycle' in rels) {
    return ['Unpaid carts', 'Carts that need attention', 'Skipped', 'Will be charged']
  } else if ('fulfillment_slot' in rels) {
    return ['Unpaid carts', 'Carts that need attention', 'Will be charged']
  } else {
    return ['Unpaid carts', 'Carts that need attention']
  }
})
const cartsTab = ref('Unpaid carts')

const bottlePair = bottle => mapRelationship(bottle?.relationships.conversation_user_pair.data)
const bottleCart = bottle => mapRelationship(bottle?.relationships.cart.data)
const bottleSlot = bottle => mapRelationship(bottle?.relationships.fulfillment_slot.data)
const cartItems = cart => mapRelationships(cart?.relationships?.cart_items?.data || [])
const bottleGroupedItems = bottle => {
  const slotDate = bottleSlot(bottle)?.attributes.fulfillment_date
  let items = cartItems(bottleCart(bottle))
  for (const item of items) item.attributes.fulfillment_group_date = item.attributes.fulfillment_group_date ?? slotDate
  items = _.sortBy(items, 'attributes.fulfillment_group_date')
  return _.groupBy(items, 'attributes.fulfillment_group_date')
}
const itemVariants = item => {
  const grouped = _.groupBy(item.attributes.variant_options_selection, 'variant_name')
  return Object.keys(grouped)
    .map(key => `${key}: ${grouped[key].map(x => x.variant_option_name).join(', ')}`)
    .join(', ')
}
const slotTime = slot => {
  if (!slot) return null
  const start = new Date(slot.attributes?.arrives_beginning_estimate)
  const end = new Date(slot.attributes?.arrives_ending_estimate)
  if (Number.isNaN(+start) || Number.isNaN(+end)) return null

  const timeFmt = new Intl.DateTimeFormat('en-US', {
    timeStyle: 'short'
  }).format

  if (timeFmt(start) === timeFmt(end)) {
    return timeFmt(start)
  } else {
    return `${timeFmt(start)} - ${timeFmt(end)}`
  }
}
const slotDate = slot => {
  if (!slot) return null
  const start = new Date(slot.attributes?.arrives_beginning_estimate)
  const end = new Date(slot.attributes?.arrives_ending_estimate)
  if (Number.isNaN(+start) || Number.isNaN(+end)) return null

  const dateFmt = new Intl.DateTimeFormat('en-US', {
    month: 'numeric',
    day: 'numeric',
    weekday: 'short'
  }).format

  if (dateFmt(start) === dateFmt(end)) {
    return dateFmt(start)
  } else {
    return `${dateFmt(start)} - ${dateFmt(end)}`
  }
}

const includedLookupKey = rel => {
  if (!rel?.type || !rel?.id) return null
  return `${rel.type}:${rel.id}`
}

const buildIncludedLookup = (included = []) => {
  const lookup = {}
  included.forEach(record => {
    lookup[`${record.type}:${record.id}`] = record
  })
  return lookup
}

const addPairsPage = payload => {
  pairs.value.push(payload?.data || [])
  pairsIncludedLookup.value.push(buildIncludedLookup(payload?.included || []))
}

const lastMessage = (pair, pageIndex = null) => {
  if (Number.isInteger(pageIndex) && pageIndex >= 0) {
    const localLookup = pairsIncludedLookup.value[pageIndex]
    if (localLookup) {
      const detailRef = pair?.relationships?.conversation_user_pair_detail?.data
      const detail = localLookup[includedLookupKey(detailRef)]
      const messageRef = detail?.relationships?.most_recent_inbound_messages?.data?.[0]
      const message = localLookup[includedLookupKey(messageRef)]
      if (message) return message
    }
  }

  const detail = mapRelationship(pair?.relationships?.conversation_user_pair_detail?.data)
  const recent = mapRelationships(detail?.relationships?.most_recent_inbound_messages?.data || [])
  return recent[0]
}

// TODO(alicja): also in MessagesNeue, extract at some point?
const automations = computed(() =>
  [...mapType('message_automation'), ...mapType('bottle_reminder_automation')]
    .filter(
      x =>
        x.attributes.status !== 'completed' &&
        automationTime(x) &&
        automationAudiences(x).some(y => y.id === audienceId.value)
    )
    ?.sort((a, b) => new Date(automationTime(a)) - new Date(automationTime(b)))
)

const reports = computed(() =>
  mapType('data_download') // newest first
    ?.filter(x => x.relationships.audience.data?.id === audienceId.value)
    ?.sort((a, b) => new Date(b.attributes.created_at) - new Date(a.attributes.created_at))
)

// uber_delivery has no audience relationship to filter mapType() by, so we keep the id list from the
// last fetch and read those objects straight out of the store (in fetch order). A merchant-cancelled
// delivery is deliberately kept is_active: false, so this reads through mapRelationship rather than
// mapType/mapRelationships, both of which drop inactive records.
const uberDeliveries = computed(() =>
  uberDeliveryIds.value.map(id => mapRelationship({ type: 'uber_delivery', id })).filter(Boolean)
)

const audienceTabs = computed(() =>
  [
    isDateAudience.value && { id: 'overview', name: 'Overview' },
    { id: 'filters', name: 'Filters' },
    !isDateAudience.value && drops.value.length && { id: 'drops', name: 'Drops' },
    { id: 'orders', name: 'Orders' },
    uberDeliveries.value.length && { id: 'uber-deliveries', name: 'Uber deliveries' },
    { id: 'carts', name: 'Unpaid carts' },
    { id: 'products', name: 'Products' },
    { id: 'customers', name: 'Customers' },
    { id: 'automations', name: 'Automations' },
    !hideNumbers.value && { id: 'reports', name: 'Reports' }
  ].filter(Boolean)
)
const tabs = computed(() => {
  const listTabs = audienceTabs.value.filter(tab => !props.onlyTabs || props.onlyTabs.includes(tab.id))
  return props.leadTab ? [props.leadTab, ...listTabs] : listTabs
})
const { activeTab, sections: audienceSections } = useRouteTabs(
  tabs,
  computed(() => props.basePath ?? `/lists/${audienceId.value}`)
)

const automationTime = automation =>
  mapRelationship(automation.relationships.automation_scheduler?.data)?.attributes.datetime

const automationDrop = automation => mapRelationship(automation.relationships.bottle_cycle?.data)

const automationAudiences = automation => mapRelationships(automation.relationships.audiences?.data)

const automationLink = automation => {
  if (automation.attributes.type === 'BottleReminderAutomation') {
    return '/store/drops/' + automationDrop(automation)?.id
  }
  if (automation.attributes.type === 'MessageAutomation') {
    return '/automation/message/' + automation.id
  }
}

const dropDays = drop =>
  mapRelationships(drop.relationships.fulfillment_availabilities.data).map(x =>
    Intl.DateTimeFormat([], {
      day: 'numeric',
      month: 'short'
    }).format(serverDayToDateObject(x.attributes.date))
  )

const dropAudienceNames = drop =>
  mapRelationships(drop.relationships.audiences.data).map(x => x.attributes.display_audience_name)

const currentFilters = computed(() => {
  const filterGroups = mapRelationships(audience.value?.relationships.filter_groups.data)
  // TODO(alicja): make sure this always holds
  console.assert(filterGroups?.length <= 1)
  const filterGroup = filterGroups[0]
  return mapRelationships(filterGroup?.relationships.filters.data)
    .map(serverFilterToLocal)
    .filter(Boolean)
    .sort((a, b) => a.id - b.id)
})

const incompleteFilter = computed(() => currentFilters.value.find(filterMissingValue))
const filterSaveType = type => (incompleteFilter.value ? 'inactive' : saveType(type))

const relativeFormat = x => (x ? timeAgo.format(new Date(x)) : '')
const absoluteFormat = x => new Intl.DateTimeFormat([], { dateStyle: 'short', timeStyle: 'short' }).format(new Date(x))

// Times only: the list is already scoped to the day being viewed. Shown in
// the merchant's time zone, falling back to the browser's when unknown.
const merchantTimeFormat = x =>
  new Intl.DateTimeFormat('en-US', {
    hour: '2-digit',
    minute: '2-digit',
    hour12: true,
    timeZone: store.state.loggedInUser?.attributes?.time_zone || undefined
  }).format(new Date(x))

const uberDeliveryWindow = delivery => {
  const start = delivery.attributes.pickup_ready_at ? merchantTimeFormat(delivery.attributes.pickup_ready_at) : 'ASAP'
  const end = delivery.attributes.dropoff_deadline_at
    ? merchantTimeFormat(delivery.attributes.dropoff_deadline_at)
    : null
  return end ? `${start} - ${end}` : start
}

const uberDeliveryStatusLabels = {
  pending: 'Booked',
  pickup: 'Courier en route',
  pickup_complete: 'Picked up',
  dropoff: 'Delivering',
  delivered: 'Delivered',
  canceled: 'Cancelled',
  returned: 'Returned',
  failed: 'Failed'
}

const uberDeliveryStatusLabel = delivery => {
  if (delivery.attributes.merchant_cancelled_at) return 'Cancelled by you'
  return uberDeliveryStatusLabels[delivery.attributes.status] || delivery.attributes.status
}

const { showToast } = useToast()

// Only a root list counts against the plan limit, so a drill-down is refused only when it creates one.
const onPlanLimit = toastPlanLimit(showToast)

const makeAudienceWithFilter = async filter => {
  const filters = mergeFilter(currentFilters.value, filter)

  const response = await api
    .call('POST', 'audiences', {
      audience: {
        is_root: false,
        audience_name: `Filtered list (created ${absoluteFormat(new Date())})`,
        root_audience_id: audience.value.attributes.is_root
          ? audienceId.value
          : rootAudience.value?.id ?? audienceId.value,
        filter_groups_attributes: [{ filters_attributes: filters.map(localFilterToServer) }]
      }
    })
    .catch(onPlanLimit)
  if (!response) return
  keepPendingName = true
  await router.push('/lists/' + response.data.data.id)
  loading.value.audience = false
}

const saveAsNewAudience = async () => {
  if (audience.value.attributes.is_root) {
    const response = await api
      .call('POST', 'audiences', {
        audience: newListAttributes(nameFieldValue.value.trim(), currentFilters.value)
      })
      .catch(onPlanLimit)
    if (!response) return
    await router.push('/lists/' + response.data.data.id)
    return
  }

  await api.call('PUT', 'audiences/' + audienceId.value, {
    audience: {
      is_root: true,
      audience_name: nameFieldValue.value.trim()
    }
  })
  pendingName.value = null
}

const saveUpdatingRootAudience = async () => {
  const response = await api.call('PUT', 'audiences/' + rootAudience.value.id, {
    audience: {
      filter_groups_attributes: [{ filters_attributes: currentFilters.value.map(localFilterToServer) }],
      ...(nameChanged.value && { audience_name: pendingName.value.trim() })
    }
  })
  await router.push('/lists/' + response.data.data.id)
  loading.value.audience = false
}

const saveName = async () => {
  await api.call('PUT', 'audiences/' + audienceId.value, {
    audience: {
      audience_name: pendingName.value.trim()
    }
  })
  pendingName.value = null
}

const orderTabFilters = { packed: 'packed', unpacked: 'not_produced', arrival: 'cart_item_fulfillment_date' }
const orderTabRefs = { packed, unpacked, arrival }
const ordersTabLocalName = {
  'Unpacked orders': 'unpacked',
  'Packed orders': 'packed',
  'Orders with arrival day': 'arrival'
}
const ordersTabToKey = {
  'All orders': 'paid',
  'Unpacked orders': 'unpacked',
  'Packed orders': 'packed',
  'Orders with arrival day': 'arrival',
  'Cancelled orders': 'cancelled'
}

const reloadPaid = () => {
  loading.value.paid = true
  paid.value = []
  pagination.value.paid = { page: 0, size: null, cursor: null }
  api
    .call(
      'GET',
      `audiences/${audienceId.value}/orders_optimized?offset=${pageSize}&cursor=0&${sort.value}`,
      {},
      { abortController: controller.value, quietAbort: true }
    )
    .then(x => {
      paid.value.push(x.data.data)
      pagination.value.paid.cursor = x.data.next_cursor
      pagination.value.paid.size = x.data.total_records
      loading.value.paid = false
    })
}

const reloadCancelled = () => {
  loading.value.cancelled = true
  cancelled.value = []
  pagination.value.cancelled = { page: 0, size: null, cursor: null }
  api
    .call(
      'GET',
      `audiences/${audienceId.value}/cancelled_orders?offset=${pageSize}&cursor=0`,
      {},
      { abortController: controller.value, quietAbort: true }
    )
    .then(x => {
      cancelled.value.push(x.data.data)
      pagination.value.cancelled.cursor = x.data.next_cursor
      pagination.value.cancelled.size = x.data.total_records
      loading.value.cancelled = false
    })
}

const reloadOrderTab = name => {
  const ref = orderTabRefs[name]
  loading.value[name] = true
  ref.value = []
  pagination.value[name] = { page: 0, size: null, cursor: null }
  api
    .call(
      'GET',
      `audiences/${audienceId.value}/orders_optimized?offset=${pageSize}&cursor=0&${sort.value}&filter=${orderTabFilters[name]}`,
      {},
      { abortController: controller.value, quietAbort: true }
    )
    .then(x => {
      ref.value.push(x.data.data)
      pagination.value[name].cursor = x.data.next_cursor
      pagination.value[name].size = x.data.total_records
      loading.value[name] = false
    })
}

const reloadOrderTabCount = name => {
  api
    .call(
      'GET',
      `audiences/${audienceId.value}/orders_optimized?offset=0&cursor=0&${sort.value}&filter=${orderTabFilters[name]}`,
      {},
      { abortController: controller.value, quietAbort: true }
    )
    .then(x => {
      pagination.value[name].size = x.data.total_records
    })
}

const reloadAllOrderTabsExceptCurrent = () => {
  const currentKey = ordersTabToKey[ordersTab.value]
  recentlyCancelledOrUncancelledTabKey.value = currentKey
  for (const tabName of ordersTabs.value) {
    const key = ordersTabToKey[tabName]
    if (key && key !== currentKey) {
      if (key === 'paid') reloadPaid()
      else if (key === 'cancelled') reloadCancelled()
      else reloadOrderTab(key)
    }
  }
}

const removeBottleFromOrderList = (bottle, listRef, listName, filter) => {
  const currentPage = pagination.value[listName].page

  // Remove the bottle from the current page
  listRef.value[currentPage] = listRef.value[currentPage].filter(b => b.id !== bottle.id)

  // Cascade: pull first item from each subsequent cached page to fill the gap
  for (let i = currentPage; i < listRef.value.length - 1; i++) {
    const nextPage = listRef.value[i + 1]
    if (nextPage.length > 0) {
      listRef.value[i].push(nextPage.shift())
    }
  }

  // If the last cached page is now empty, remove it
  if (listRef.value.length > 0 && listRef.value[listRef.value.length - 1].length === 0) {
    listRef.value.pop()
  }

  // If there's a cursor (more items on the server), fetch 1 replacement.
  // Recalculate the cursor from how many items we currently have cached,
  // because the old cursor is stale after the item was removed server-side.
  if (pagination.value[listName].cursor) {
    const totalCachedItems = listRef.value.reduce((sum, page) => sum + page.length, 0)
    api
      .call(
        'GET',
        `audiences/${audienceId.value}/orders_optimized?offset=1&cursor=${totalCachedItems}&${sort.value}&filter=${filter}`
      )
      .then(x => {
        if (x.data.data.length > 0) {
          if (listRef.value.length > 0) {
            listRef.value[listRef.value.length - 1].push(...x.data.data)
          } else {
            listRef.value.push(x.data.data)
          }
        }
        pagination.value[listName].cursor = x.data.next_cursor ? totalCachedItems + 1 : null
      })
  }

  // If current page is now out of bounds, go back
  if (currentPage > 0 && currentPage >= listRef.value.length) {
    pagination.value[listName].page = listRef.value.length - 1
  }

  // Decrement total count
  pagination.value[listName].size = Math.max(0, (pagination.value[listName].size || 0) - 1)
}

const markPacked = bottle => {
  if (!canUpdateOrders.value) return
  packingBottle.value[bottle.id] = true
  api
    .call('PUT', `bottles/${bottle.id}`, {
      bottle: { production_statuses_attributes: [{ production_status: 'packed' }] }
    })
    .then(() => {
      packingBottle.value[bottle.id] = false
      bottle.attributes.production_status = 'packed'
      removeBottleFromOrderList(bottle, unpacked, 'unpacked', 'not_produced')
      const currentTab = ordersTabLocalName[ordersTab.value]
      for (const tab of ['packed', 'unpacked', 'arrival']) {
        if (tab !== currentTab) reloadOrderTab(tab)
      }
      if (currentTab) reloadOrderTabCount(currentTab)
    })
}
const markNotPacked = bottle => {
  if (!canUpdateOrders.value) return
  packingBottle.value[bottle.id] = true
  api
    .call('PUT', `bottles/${bottle.id}`, {
      bottle: { production_statuses_attributes: [{ production_status: 'not_produced' }] }
    })
    .then(() => {
      packingBottle.value[bottle.id] = false
      bottle.attributes.production_status = 'not_produced'
      removeBottleFromOrderList(bottle, packed, 'packed', 'packed')
      const currentTab = ordersTabLocalName[ordersTab.value]
      for (const tab of ['packed', 'unpacked', 'arrival']) {
        if (tab !== currentTab) reloadOrderTab(tab)
      }
      if (currentTab) reloadOrderTabCount(currentTab)
    })
}

const cancelDelivery = async delivery => {
  if (!canUpdateOrders.value || !delivery.attributes.cancellable) return
  if (!confirm('Cancel the courier for this delivery?')) return

  deliveryError.value = ''
  cancellingDelivery.value[delivery.id] = true
  try {
    await api.call('POST', `uber_deliveries/${delivery.id}/cancel`)
    await loadUberDeliveries(audienceId.value)
  } catch (e) {
    deliveryError.value = e.response?.data?.errors?.[0] || 'Could not cancel the courier'
  } finally {
    cancellingDelivery.value[delivery.id] = false
  }
}

const deleteModal = ref({ open: false, loading: false })

const del = async () => {
  deleteModal.value.loading = true
  try {
    await api.call('PUT', 'audiences/' + audienceId.value, {
      audience: {
        is_root: false
      }
    })
    deleteModal.value.open = false
    router.push('/lists')
  } finally {
    deleteModal.value.loading = false
  }
}

watch(ordersTab, (newVal, oldVal) => {
  if (oldVal !== undefined) {
    if (ordersTabLocalName[oldVal]) {
      reloadOrderTab(ordersTabLocalName[oldVal])
    }
    const leftTabKey = ordersTabToKey[oldVal]
    if (recentlyCancelledOrUncancelledTabKey.value === leftTabKey && leftTabKey) {
      if (leftTabKey === 'paid') reloadPaid()
      else if (leftTabKey === 'cancelled') reloadCancelled()
      else reloadOrderTab(leftTabKey)
      recentlyCancelledOrUncancelledTabKey.value = null
    }
  }
})

let listAudienceId = null
let panelsAudienceId = null
watch(
  [audienceId, activeTab],
  ([id, tab]) => {
    if (id !== listAudienceId) {
      listAudienceId = id
      panelsAudienceId = null
      loadList(id)
    }
    if (id === panelsAudienceId || (props.leadTab && tab === props.leadTab.id)) return
    panelsAudienceId = id
    loadPanels(id)
  },
  { immediate: true }
)

return (_ctx, _cache) => {
  const _component_SecondaryTop = _resolveComponent("SecondaryTop")
  const _component_NewReportModal = _resolveComponent("NewReportModal")
  const _component_NeueButton = _resolveComponent("NeueButton")
  const _component_TheModal = _resolveComponent("TheModal")
  const _component_NeueLoading = _resolveComponent("NeueLoading")
  const _component_DescriptionHeader = _resolveComponent("DescriptionHeader")
  const _component_TablistHeader = _resolveComponent("TablistHeader")
  const _component_router_link = _resolveComponent("router-link")
  const _component_TablistRow = _resolveComponent("TablistRow")
  const _component_NeueTablist = _resolveComponent("NeueTablist")
  const _component_EmptyState = _resolveComponent("EmptyState")
  const _component_NeueWell = _resolveComponent("NeueWell")
  const _component_InputField = _resolveComponent("InputField")
  const _component_SelectInput = _resolveComponent("SelectInput")
  const _component_BasicSpinner = _resolveComponent("BasicSpinner")
  const _component_NeuePagination = _resolveComponent("NeuePagination")
  const _component_PageFooter = _resolveComponent("PageFooter")
  const _component_SecondaryNav = _resolveComponent("SecondaryNav")

  return (_openBlock(), _createBlock(_component_SecondaryNav, null, {
    top: _withCtx(() => [
      _renderSlot(_ctx.$slots, "top", { sections: _unref(audienceSections) }, () => [
        _createVNode(_component_SecondaryTop, {
          parent: backLink.value,
          text: pendingName.value?.trim() || audience.value?.attributes.audience_name,
          sections: _unref(audienceSections)
        }, null, 8, ["parent", "text", "sections"])
      ])
    ]),
    main: _withCtx(() => [
      (audience.value)
        ? (_openBlock(), _createBlock(_component_NewReportModal, {
            key: 0,
            "is-open": reportsModalOpen.value,
            audience: audience.value,
            onCloseModal: _cache[0] || (_cache[0] = $event => (reportsModalOpen.value = false))
          }, null, 8, ["is-open", "audience"]))
        : _createCommentVNode("", true),
      _createVNode(_component_TheModal, {
        "is-open": deleteModal.value.open,
        "modal-title": "Delete list?",
        onCloseModal: _cache[2] || (_cache[2] = $event => (deleteModal.value.open = false))
      }, {
        main: _withCtx(() => [
          _createElementVNode("p", _hoisted_1, [
            _cache[31] || (_cache[31] = _createTextVNode(" This removes ", -1)),
            _createElementVNode("span", _hoisted_2, _toDisplayString(audience.value?.attributes.audience_name), 1),
            _cache[32] || (_cache[32] = _createTextVNode(" from your lists. The customers in it aren't affected. ", -1))
          ])
        ]),
        footer: _withCtx(() => [
          _createVNode(_component_NeueButton, {
            type: "red",
            disabled: deleteModal.value.loading,
            class: "mr-3",
            onClick: del
          }, {
            default: _withCtx(() => [...(_cache[33] || (_cache[33] = [
              _createTextVNode("Delete", -1)
            ]))]),
            _: 1
          }, 8, ["disabled"]),
          _createVNode(_component_NeueButton, {
            type: "secondary",
            disabled: deleteModal.value.loading,
            onClick: _cache[1] || (_cache[1] = $event => (deleteModal.value.open = false))
          }, {
            default: _withCtx(() => [...(_cache[34] || (_cache[34] = [
              _createTextVNode(" Cancel ", -1)
            ]))]),
            _: 1
          }, 8, ["disabled"])
        ]),
        _: 1
      }, 8, ["is-open"]),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          (__props.leadTab)
            ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_5, [
                _renderSlot(_ctx.$slots, "lead")
              ], 512)), [
                [_vShow, _unref(activeTab) === __props.leadTab.id]
              ])
            : _createCommentVNode("", true),
          _withDirectives(_createElementVNode("div", _hoisted_6, [
            (isDateAudience.value)
              ? (_openBlock(), _createBlock(_component_NeueLoading, {
                  key: 0,
                  loading: loading.value.detail
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("dl", _hoisted_7, [
                      _createElementVNode("div", _hoisted_8, [
                        _cache[37] || (_cache[37] = _createElementVNode("dt", { class: "text-sm font-medium text-gray-600" }, "Cart subscribers", -1)),
                        _createElementVNode("dd", _hoisted_9, _toDisplayString(activityDetail.value?.attributes.number_of_cart_subscriptions), 1),
                        _createElementVNode("dd", _hoisted_10, [
                          _cache[35] || (_cache[35] = _createTextVNode(" Autocharge: ", -1)),
                          _createElementVNode("span", _hoisted_11, _toDisplayString(activityDetail.value?.attributes.number_of_autocharge_cart_subscriptions), 1)
                        ]),
                        _createElementVNode("dd", _hoisted_12, [
                          _cache[36] || (_cache[36] = _createTextVNode(" Non-autocharge: ", -1)),
                          _createElementVNode("span", _hoisted_13, _toDisplayString(activityDetail.value?.attributes.number_of_non_autocharge_cart_subscriptions), 1)
                        ])
                      ]),
                      _createElementVNode("div", {
                        class: _normalizeClass(["rounded-lg bg-white px-4 py-5 shadow sm:p-6", hideNumbers.value ? 'blur-lg' : ''])
                      }, [
                        _cache[40] || (_cache[40] = _createElementVNode("dt", { class: "text-sm font-medium text-gray-600" }, "Total amount", -1)),
                        _createElementVNode("dd", _hoisted_14, _toDisplayString(detail.value?.attributes.sum_of_paid_orders.format), 1),
                        _createElementVNode("dd", _hoisted_15, [
                          _cache[38] || (_cache[38] = _createTextVNode(" Charged amount: ", -1)),
                          _createElementVNode("span", _hoisted_16, _toDisplayString(detail.value?.attributes.sum_of_charged_amount.format), 1)
                        ]),
                        _createElementVNode("dd", _hoisted_17, [
                          _cache[39] || (_cache[39] = _createTextVNode(" Average cart value: ", -1)),
                          _createElementVNode("span", _hoisted_18, _toDisplayString(detail.value?.attributes.average_order_total.format), 1)
                        ])
                      ], 2),
                      _createElementVNode("div", _hoisted_19, [
                        _cache[41] || (_cache[41] = _createElementVNode("dt", { class: "text-sm font-medium text-gray-600" }, "Orders", -1)),
                        _createElementVNode("dd", _hoisted_20, _toDisplayString(detail.value?.attributes.number_of_paid_orders), 1)
                      ])
                    ])
                  ]),
                  _: 1
                }, 8, ["loading"]))
              : _createCommentVNode("", true),
            (drops.value?.length || isDateAudience.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                  (isDateAudience.value)
                    ? (_openBlock(), _createBlock(_component_DescriptionHeader, {
                        key: 0,
                        name: "Drops"
                      }))
                    : _createCommentVNode("", true),
                  (drops.value?.length)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                        _createVNode(_component_NeueTablist, null, {
                          head: _withCtx(() => [
                            _createVNode(_component_TablistHeader, null, {
                              default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_23, [
                                  _createVNode(TablistGrid, {
                                    columns: dropsCols,
                                    header: "",
                                    class: "flex-1"
                                  }, {
                                    default: _withCtx(() => [...(_cache[42] || (_cache[42] = [
                                      _createElementVNode("div", null, "List", -1),
                                      _createElementVNode("div", null, "Customers", -1),
                                      _createElementVNode("div", null, "Skipped", -1)
                                    ]))]),
                                    _: 1
                                  }),
                                  _cache[43] || (_cache[43] = _createElementVNode("div", { class: "w-[110px] flex-shrink-0" }, null, -1))
                                ])
                              ]),
                              _: 1
                            })
                          ]),
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(drops.value, (drop) => {
                              return (_openBlock(), _createBlock(_component_TablistRow, {
                                key: drop.id,
                                class: "cursor-pointer",
                                onClick: $event => (_unref(router).push('/lists/' + drop.relationships.bottle_cycle_audience?.data?.id))
                              }, {
                                default: _withCtx(() => [
                                  _createElementVNode("div", _hoisted_24, [
                                    _createVNode(TablistGrid, {
                                      columns: dropsCols,
                                      class: "flex-1 items-center"
                                    }, {
                                      default: _withCtx(() => [
                                        _createElementVNode("div", _hoisted_25, [
                                          (isDateAudience.value)
                                            ? (_openBlock(), _createElementBlock("span", _hoisted_26, _toDisplayString(dropAudienceNames(drop).join(', ')), 1))
                                            : (_openBlock(), _createElementBlock("span", _hoisted_27, _toDisplayString(dropDays(drop).join(', ')), 1))
                                        ]),
                                        _createElementVNode("div", null, _toDisplayString(_unref(mapRelationship)(drop.relationships.bottle_cycle_detail.data)?.relationships
                              .conversation_user_pairs.data.length), 1),
                                        _createElementVNode("div", null, _toDisplayString(_unref(mapRelationship)(drop.relationships.bottle_cycle_detail.data)?.relationships
                              .skipped_conversation_user_pairs.data.length), 1)
                                      ]),
                                      _: 2
                                    }, 1024),
                                    _createElementVNode("div", {
                                      class: "flex items-center gap-2 shrink-0 w-[110px] justify-end",
                                      onClick: _cache[3] || (_cache[3] = _withModifiers(() => {}, ["stop"]))
                                    }, [
                                      (!drop.attributes.open_for_ordering)
                                        ? (_openBlock(), _createBlock(_unref(ExclamationTriangleIcon), {
                                            key: 0,
                                            class: "inline h-5 w-5 text-yellow-400"
                                          }))
                                        : _createCommentVNode("", true),
                                      _createVNode(_component_router_link, {
                                        class: "cursor-pointer text-blue-600",
                                        to: '/lists/' + drop.relationships.bottle_cycle_audience?.data?.id
                                      }, {
                                        default: _withCtx(() => [...(_cache[44] || (_cache[44] = [
                                          _createTextVNode(" View ", -1)
                                        ]))]),
                                        _: 1
                                      }, 8, ["to"]),
                                      _createVNode(_component_router_link, {
                                        class: "cursor-pointer text-blue-600",
                                        to: '/store/drops/' + drop.id
                                      }, {
                                        default: _withCtx(() => [...(_cache[45] || (_cache[45] = [
                                          _createTextVNode(" Edit ", -1)
                                        ]))]),
                                        _: 1
                                      }, 8, ["to"])
                                    ])
                                  ])
                                ]),
                                _: 2
                              }, 1032, ["onClick"]))
                            }), 128))
                          ]),
                          _: 1
                        })
                      ]))
                    : _createCommentVNode("", true),
                  (!drops.value?.length)
                    ? (_openBlock(), _createBlock(_component_NeueWell, { key: 2 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_EmptyState, {
                            plural: "drops",
                            description: ""
                          })
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true),
            (isDateAudience.value && (!drops.value.length || drops.value.some(x => !x.attributes.open_for_ordering)))
              ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                  _createElementVNode("div", _hoisted_29, [
                    _createElementVNode("div", _hoisted_30, [
                      _cache[46] || (_cache[46] = _createElementVNode("h3", { class: "text-2xl font-bold text-gray-600 tracking-tighter" }, "Cart subscribers", -1)),
                      (cartSubscribers.value.length)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_31, _toDisplayString(cartSubscribers.value.length), 1))
                        : _createCommentVNode("", true),
                      _createVNode(_unref(ExclamationTriangleIcon), { class: "h-6 w-6 ml-2 text-yellow-400" })
                    ])
                  ]),
                  _createVNode(_component_NeueLoading, {
                    loading: loading.value.cartSubscribers
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_32, [
                        _createVNode(_component_NeueTablist, null, {
                          head: _withCtx(() => [
                            _createVNode(_component_TablistHeader, null, {
                              default: _withCtx(() => [
                                _createVNode(TablistGrid, {
                                  columns: cartSubscribersCols,
                                  header: ""
                                }, {
                                  default: _withCtx(() => [...(_cache[47] || (_cache[47] = [
                                    _createElementVNode("div", null, "Customer", -1),
                                    _createElementVNode("div", null, "Last Message", -1),
                                    _createElementVNode("div", null, "Sent Time", -1)
                                  ]))]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(cartSubscribers.value, (pair) => {
                              return (_openBlock(), _createBlock(_component_TablistRow, {
                                key: pair.id,
                                class: "cursor-pointer",
                                onClick: $event => (_unref(router).push('/messages/' + pair.id))
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(TablistGrid, {
                                    columns: cartSubscribersCols,
                                    class: "items-center"
                                  }, {
                                    default: _withCtx(() => [
                                      _createElementVNode("div", _hoisted_33, _toDisplayString(pair.attributes.display_name), 1),
                                      _createElementVNode("div", _hoisted_34, _toDisplayString(lastMessage(pair)?.attributes.body_decoded), 1),
                                      (_openBlock(), _createElementBlock("div", { key: cachebuster.value }, _toDisplayString(relativeFormat(pair.attributes.last_sent_timestamp)), 1))
                                    ]),
                                    _: 2
                                  }, 1024)
                                ]),
                                _: 2
                              }, 1032, ["onClick"]))
                            }), 128))
                          ]),
                          _: 1
                        })
                      ])
                    ]),
                    _: 1
                  }, 8, ["loading"])
                ]))
              : _createCommentVNode("", true)
          ], 512), [
            [_vShow, _unref(activeTab) === 'drops' || (!__props.leadTab && _unref(activeTab) === 'overview')]
          ]),
          _withDirectives(_createElementVNode("div", _hoisted_35, [
            (audience.value && !audience.value.attributes.created_by_bottle)
              ? (_openBlock(), _createBlock(SettingsSection, {
                  key: 0,
                  title: "Details",
                  description: "What this list is called here and anywhere you pick it, like automations and drops."
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_InputField, {
                      name: "Name",
                      "model-value": nameFieldValue.value,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = name => (pendingName.value = name))
                    }, null, 8, ["model-value"])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            _createVNode(SettingsSection, {
              title: "Filters",
              description: "Who is in this list. Changing a filter opens an unsaved copy of the list for you to save.",
              plain: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_NeueLoading, {
                  loading: loading.value.audience
                }, {
                  default: _withCtx(() => [
                    _createVNode(ListFilterEditor, {
                      filters: currentFilters.value,
                      onChange: makeAudienceWithFilter
                    }, null, 8, ["filters"]),
                    (!loading.value.audience && (!audience.value?.attributes.is_root || nameChanged.value))
                      ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
                          (!audience.value?.attributes.is_root && rootAudience.value)
                            ? (_openBlock(), _createBlock(_component_router_link, {
                                key: 0,
                                to: '/lists/' + rootAudience.value.id,
                                class: "block mt-4 -mb-6"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_NeueButton, { type: "secondary" }, {
                                    default: _withCtx(() => [...(_cache[48] || (_cache[48] = [
                                      _createTextVNode("<-- Back to original list", -1)
                                    ]))]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }, 8, ["to"]))
                            : (audience.value?.attributes.is_root)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                                  _createVNode(_component_NeueButton, {
                                    type: "secondary",
                                    onClick: _cache[5] || (_cache[5] = $event => (pendingName.value = null))
                                  }, {
                                    default: _withCtx(() => [...(_cache[49] || (_cache[49] = [
                                      _createTextVNode("Discard", -1)
                                    ]))]),
                                    _: 1
                                  })
                                ]))
                              : _createCommentVNode("", true),
                          (canWriteCustomers.value)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                                (incompleteFilter.value)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_39, " Pick a value for " + _toDisplayString(_unref(filterOptions)[incompleteFilter.value.type].name) + " to save ", 1))
                                  : (_openBlock(), _createElementBlock("div", _hoisted_40, "Unsaved changes")),
                                (updateTarget.value && !updateTarget.value.attributes.created_by_bottle)
                                  ? (_openBlock(), _createBlock(_component_NeueButton, {
                                      key: 2,
                                      type: audience.value.attributes.is_root ? saveType('secondary') : filterSaveType('secondary'),
                                      class: "whitespace-nowrap mr-3",
                                      onClick: _cache[6] || (_cache[6] = $event => (audience.value.attributes.is_root ? saveName() : saveUpdatingRootAudience()))
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(" Update " + _toDisplayString((nameChanged.value && pendingName.value.trim()) || updateTarget.value.attributes.audience_name), 1)
                                      ]),
                                      _: 1
                                    }, 8, ["type"]))
                                  : _createCommentVNode("", true),
                                _createVNode(_component_NeueButton, {
                                  type: filterSaveType('primary'),
                                  class: "whitespace-nowrap",
                                  onClick: saveAsNewAudience
                                }, {
                                  default: _withCtx(() => [...(_cache[50] || (_cache[50] = [
                                    _createTextVNode(" Save as a new list ", -1)
                                  ]))]),
                                  _: 1
                                }, 8, ["type"])
                              ]))
                            : _createCommentVNode("", true)
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }, 8, ["loading"])
              ]),
              _: 1
            })
          ], 512), [
            [_vShow, _unref(activeTab) === 'filters']
          ]),
          _withDirectives(_createElementVNode("div", _hoisted_41, [
            _createElementVNode("div", _hoisted_42, [
              _createElementVNode("div", _hoisted_43, [
                _createVNode(_component_SelectInput, {
                  modelValue: ordersTab.value,
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => ((ordersTab).value = $event)),
                  options: ordersTabs.value.map(tab => ({ name: tab, value: tab }))
                }, null, 8, ["modelValue", "options"])
              ]),
              _createElementVNode("div", _hoisted_44, [
                _createElementVNode("nav", _hoisted_45, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(ordersTabs.value, (tab) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: tab,
                      class: _normalizeClass([
                      ordersTab.value === tab ? 'bg-gray-100 text-gray-700' : 'text-gray-500 hover:text-gray-700',
                      'px-3 py-2 font-medium text-sm rounded-md cursor-pointer flex items-center mr-4'
                    ]),
                      "aria-current": ordersTab.value === tab ? 'page' : undefined,
                      onClick: $event => (ordersTab.value = tab)
                    }, [
                      _createTextVNode(_toDisplayString(tab) + " ", 1),
                      _createElementVNode("span", _hoisted_47, [
                        (
                          {
                            'All orders': pagination.value.paid.size != null,
                            'Unpacked orders': pagination.value.unpacked.size != null,
                            'Packed orders': pagination.value.packed.size != null,
                            'Orders with arrival day': pagination.value.arrival.size != null,
                            'Cancelled orders':
                              detail.value?.attributes.number_of_cancelled_orders || pagination.value.cancelled.size != null
                          }[tab]
                        )
                          ? (_openBlock(), _createElementBlock("span", _hoisted_48, _toDisplayString({
                            'All orders': pagination.value.paid.size,
                            'Unpacked orders': pagination.value.unpacked.size,
                            'Packed orders': pagination.value.packed.size,
                            'Orders with arrival day': pagination.value.arrival.size,
                            'Cancelled orders':
                              pagination.value.cancelled.size ?? detail.value?.attributes.number_of_cancelled_orders
                          }[tab]), 1))
                          : (_openBlock(), _createBlock(_component_BasicSpinner, {
                              key: 1,
                              size: "small"
                            }))
                      ])
                    ], 10, _hoisted_46))
                  }), 128))
                ])
              ])
            ]),
            (
                ordersTab.value === 'All orders' ||
                ordersTab.value === 'Unpacked orders' ||
                ordersTab.value === 'Packed orders' ||
                ordersTab.value === 'Orders with arrival day'
              )
              ? (_openBlock(), _createElementBlock("div", _hoisted_49, [
                  _createElementVNode("div", _hoisted_50, [
                    _createVNode(_component_SelectInput, {
                      modelValue: sort.value,
                      "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => ((sort).value = $event)),
                      name: "Sort by",
                      options: [
                    {
                      name: 'Payment time (ascending)',
                      value: 'sort_by_field=bottle_payments.created_at&sort_direction=asc'
                    },
                    {
                      name: 'Payment time (descending)',
                      value: 'sort_by_field=bottle_payments.created_at&sort_direction=desc'
                    },
                    { name: 'Customer name (ascending)', value: 'sort_by_field=users.user_name&sort_direction=asc' },
                    { name: 'Customer name (descending)', value: 'sort_by_field=users.user_name&sort_direction=desc' }
                  ],
                      onChange: reloadOrders
                    }, null, 8, ["modelValue"])
                  ]),
                  (
                  loading.value[
                    {
                      'All orders': 'paid',
                      'Unpacked orders': 'unpacked',
                      'Packed orders': 'packed',
                      'Orders with arrival day': 'arrival'
                    }[ordersTab.value]
                  ]
                )
                    ? (_openBlock(), _createBlock(_component_BasicSpinner, {
                        key: 0,
                        size: "custom",
                        class: "h-6 w-6 mb-2"
                      }))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true),
            _withDirectives(_createElementVNode("div", null, [
              _createVNode(_component_NeueLoading, {
                loading: loading.value.paid
              }, {
                default: _withCtx(() => [
                  (paid.value[pagination.value.paid.page]?.length)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_51, [
                        _createElementVNode("div", _hoisted_52, [
                          _createVNode(_component_NeueTablist, null, {
                            head: _withCtx(() => [
                              _createVNode(_component_TablistHeader, null, {
                                default: _withCtx(() => [
                                  _createVNode(TablistGrid, {
                                    columns: ['All orders'],
                                    header: ""
                                  }, {
                                    default: _withCtx(() => [...(_cache[51] || (_cache[51] = [
                                      _createElementVNode("div", null, "All orders", -1)
                                    ]))]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })
                            ]),
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(paid.value[pagination.value.paid.page], (bottle) => {
                                return (_openBlock(), _createBlock(_component_TablistRow, {
                                  key: bottle.id
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_unref(BottleRow), {
                                      bottle: bottle,
                                      lite: "",
                                      onOrderStatusChanged: reloadAllOrderTabsExceptCurrent
                                    }, null, 8, ["bottle"])
                                  ]),
                                  _: 2
                                }, 1024))
                              }), 128))
                            ]),
                            _: 1
                          })
                        ]),
                        _createVNode(_component_NeuePagination, {
                          size: pagination.value.paid.size,
                          from: 1 + pagination.value.paid.page * pageSize,
                          to: (1 + pagination.value.paid.page) * pageSize,
                          onPrev: _cache[9] || (_cache[9] = ret => ordersPrev('All orders', ret)),
                          onNext: _cache[10] || (_cache[10] = ret => ordersNext('All orders', ret))
                        }, null, 8, ["size", "from", "to"])
                      ]))
                    : _createCommentVNode("", true),
                  (!paid.value[pagination.value.paid.page]?.length)
                    ? (_openBlock(), _createBlock(_component_NeueWell, {
                        key: 1,
                        class: "text-center"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_EmptyState, {
                            plural: "paid orders",
                            description: ""
                          })
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }, 8, ["loading"])
            ], 512), [
              [_vShow, ordersTab.value === 'All orders']
            ]),
            _withDirectives(_createElementVNode("div", null, [
              _createVNode(_component_NeueLoading, {
                loading: ordersTab.value === 'Packed orders' ? loading.value.packed : loading.value.unpacked
              }, {
                default: _withCtx(() => [
                  (
                    ordersTab.value === 'Packed orders'
                      ? packed.value[pagination.value.packed.page]?.length
                      : unpacked.value[pagination.value.unpacked.page]?.length
                  )
                    ? (_openBlock(), _createElementBlock("div", _hoisted_53, [
                        _createElementVNode("div", _hoisted_54, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(ordersTab.value === 'Packed orders'
                        ? packed.value[pagination.value.packed.page]
                        : unpacked.value[pagination.value.unpacked.page], (bottle) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: `order-card-${bottle.id}`,
                              class: "w-64 h-auto rounded-lg bg-white shadow-md border border-gray-200 flex flex-col justify-between"
                            }, [
                              _createVNode(_component_router_link, {
                                to: `/order/${bottle.id}`,
                                class: "w-full"
                              }, {
                                default: _withCtx(() => [
                                  _createElementVNode("div", _hoisted_55, [
                                    _createElementVNode("div", _hoisted_56, [
                                      _createElementVNode("div", _hoisted_57, [
                                        _createElementVNode("div", _hoisted_58, [
                                          _createElementVNode("h3", _hoisted_59, _toDisplayString(bottlePair(bottle)?.attributes.display_name), 1),
                                          _createElementVNode("p", _hoisted_60, "#" + _toDisplayString(bottle.attributes.display_id), 1)
                                        ]),
                                        _createElementVNode("div", _hoisted_61, [
                                          _createElementVNode("h4", _hoisted_62, _toDisplayString(slotTime(bottleSlot(bottle))), 1),
                                          _createElementVNode("p", _hoisted_63, _toDisplayString(slotDate(bottleSlot(bottle))), 1)
                                        ])
                                      ])
                                    ]),
                                    _createElementVNode("div", _hoisted_64, [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(bottleGroupedItems(bottle), (items, group) => {
                                        return (_openBlock(), _createElementBlock("div", { key: group }, [
                                          (Object.keys(bottleGroupedItems(bottle)).length > 1)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_65, [
                                                _cache[52] || (_cache[52] = _createTextVNode(" Items for ", -1)),
                                                _createElementVNode("span", _hoisted_66, _toDisplayString(new Intl.DateTimeFormat('en-US', {
                                      month: 'numeric',
                                      day: 'numeric',
                                      weekday: 'short'
                                    }).format(_unref(serverDayToDateObject)(group))), 1)
                                              ]))
                                            : _createCommentVNode("", true),
                                          _createElementVNode("div", _hoisted_67, [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(items, (item) => {
                                              return (_openBlock(), _createElementBlock("div", {
                                                key: item.id,
                                                class: "flex items-start gap-x-3"
                                              }, [
                                                _createElementVNode("div", _hoisted_68, _toDisplayString(item.attributes.quantity), 1),
                                                _createElementVNode("div", _hoisted_69, [
                                                  _createElementVNode("div", _hoisted_70, _toDisplayString(item.attributes.product_name), 1),
                                                  (itemVariants(item))
                                                    ? (_openBlock(), _createElementBlock("div", _hoisted_71, " (" + _toDisplayString(itemVariants(item)) + ") ", 1))
                                                    : _createCommentVNode("", true)
                                                ])
                                              ]))
                                            }), 128))
                                          ])
                                        ]))
                                      }), 128))
                                    ])
                                  ])
                                ]),
                                _: 2
                              }, 1032, ["to"]),
                              _createElementVNode("div", _hoisted_72, [
                                (canUpdateOrders.value && bottle?.attributes.production_status === 'not_produced')
                                  ? (_openBlock(), _createBlock(_component_NeueButton, {
                                      key: 0,
                                      type: "secondary",
                                      disabled: packingBottle.value[bottle.id],
                                      class: "w-full",
                                      onClick: $event => (markPacked(bottle))
                                    }, {
                                      default: _withCtx(() => [
                                        _cache[53] || (_cache[53] = _createTextVNode(" Mark as packed ", -1)),
                                        (packingBottle.value[bottle.id])
                                          ? (_openBlock(), _createBlock(_component_BasicSpinner, {
                                              key: 0,
                                              size: "small",
                                              class: "ml-2"
                                            }))
                                          : _createCommentVNode("", true)
                                      ]),
                                      _: 2
                                    }, 1032, ["disabled", "onClick"]))
                                  : _createCommentVNode("", true),
                                (canUpdateOrders.value && bottle?.attributes.production_status === 'packed')
                                  ? (_openBlock(), _createBlock(_component_NeueButton, {
                                      key: 1,
                                      type: "secondary",
                                      disabled: packingBottle.value[bottle.id],
                                      class: "w-full",
                                      onClick: $event => (markNotPacked(bottle))
                                    }, {
                                      default: _withCtx(() => [
                                        _cache[54] || (_cache[54] = _createTextVNode(" Mark not packed ", -1)),
                                        (packingBottle.value[bottle.id])
                                          ? (_openBlock(), _createBlock(_component_BasicSpinner, {
                                              key: 0,
                                              size: "small",
                                              class: "ml-2"
                                            }))
                                          : _createCommentVNode("", true)
                                      ]),
                                      _: 2
                                    }, 1032, ["disabled", "onClick"]))
                                  : _createCommentVNode("", true)
                              ])
                            ]))
                          }), 128))
                        ]),
                        _createVNode(_component_NeuePagination, {
                          size: ordersTab.value === 'Packed orders' ? pagination.value.packed.size : pagination.value.unpacked.size,
                          from: 
                      1 + (ordersTab.value === 'Packed orders' ? pagination.value.packed.page : pagination.value.unpacked.page) * pageSize
                    ,
                          to: 
                      (1 + (ordersTab.value === 'Packed orders' ? pagination.value.packed.page : pagination.value.unpacked.page)) *
                      pageSize
                    ,
                          onPrev: _cache[11] || (_cache[11] = 
                      ret =>
                        ordersTab.value === 'Packed orders'
                          ? ordersPrev('Packed orders', ret)
                          : ordersPrev('Unpacked orders', ret)
                    ),
                          onNext: _cache[12] || (_cache[12] = 
                      ret =>
                        ordersTab.value === 'Packed orders'
                          ? ordersNext('Packed orders', ret)
                          : ordersNext('Unpacked orders', ret)
                    )
                        }, null, 8, ["size", "from", "to"])
                      ]))
                    : _createCommentVNode("", true),
                  (
                    !(ordersTab.value === 'Packed orders'
                      ? packed.value[pagination.value.packed.page]?.length
                      : unpacked.value[pagination.value.unpacked.page]?.length)
                  )
                    ? (_openBlock(), _createBlock(_component_NeueWell, {
                        key: 1,
                        class: "text-center"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_EmptyState, {
                            plural: (ordersTab.value === 'Packed orders' ? '' : 'un') + 'packed orders',
                            description: ""
                          }, null, 8, ["plural"])
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }, 8, ["loading"])
            ], 512), [
              [_vShow, ordersTab.value === 'Unpacked orders' || ordersTab.value === 'Packed orders']
            ]),
            _withDirectives(_createElementVNode("div", null, [
              _createVNode(_component_NeueLoading, {
                loading: loading.value.arrival
              }, {
                default: _withCtx(() => [
                  (arrival.value[pagination.value.arrival.page]?.length)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_73, [
                        _createElementVNode("div", _hoisted_74, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(arrival.value[pagination.value.arrival.page], (bottle) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: `arrival-card-${bottle.id}`,
                              class: "w-64 h-auto rounded-lg bg-white shadow-md border border-gray-200 flex flex-col justify-between"
                            }, [
                              _createVNode(_component_router_link, {
                                to: `/order/${bottle.id}`,
                                class: "w-full"
                              }, {
                                default: _withCtx(() => [
                                  _createElementVNode("div", _hoisted_75, [
                                    _createElementVNode("div", _hoisted_76, [
                                      _createElementVNode("div", _hoisted_77, [
                                        _createElementVNode("div", _hoisted_78, [
                                          _createElementVNode("h3", _hoisted_79, _toDisplayString(bottlePair(bottle)?.attributes.display_name), 1),
                                          _createElementVNode("p", _hoisted_80, "#" + _toDisplayString(bottle.attributes.display_id), 1)
                                        ]),
                                        _createElementVNode("div", _hoisted_81, [
                                          _createElementVNode("h4", _hoisted_82, _toDisplayString(slotTime(bottleSlot(bottle))), 1),
                                          _createElementVNode("p", _hoisted_83, _toDisplayString(slotDate(bottleSlot(bottle))), 1)
                                        ])
                                      ])
                                    ]),
                                    _createElementVNode("div", _hoisted_84, [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(bottleGroupedItems(bottle), (items, group) => {
                                        return (_openBlock(), _createElementBlock("div", { key: group }, [
                                          (Object.keys(bottleGroupedItems(bottle)).length > 1)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_85, [
                                                _cache[55] || (_cache[55] = _createTextVNode(" Items for ", -1)),
                                                _createElementVNode("span", _hoisted_86, _toDisplayString(new Intl.DateTimeFormat('en-US', {
                                      month: 'numeric',
                                      day: 'numeric',
                                      weekday: 'short'
                                    }).format(_unref(serverDayToDateObject)(group))), 1)
                                              ]))
                                            : _createCommentVNode("", true),
                                          _createElementVNode("div", _hoisted_87, [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(items, (item) => {
                                              return (_openBlock(), _createElementBlock("div", {
                                                key: item.id,
                                                class: "flex items-start gap-x-3"
                                              }, [
                                                _createElementVNode("div", _hoisted_88, _toDisplayString(item.attributes.quantity), 1),
                                                _createElementVNode("div", _hoisted_89, [
                                                  _createElementVNode("div", _hoisted_90, _toDisplayString(item.attributes.product_name), 1),
                                                  (itemVariants(item))
                                                    ? (_openBlock(), _createElementBlock("div", _hoisted_91, " (" + _toDisplayString(itemVariants(item)) + ") ", 1))
                                                    : _createCommentVNode("", true)
                                                ])
                                              ]))
                                            }), 128))
                                          ])
                                        ]))
                                      }), 128))
                                    ])
                                  ])
                                ]),
                                _: 2
                              }, 1032, ["to"]),
                              _createElementVNode("div", _hoisted_92, [
                                (canUpdateOrders.value && bottle?.attributes.production_status === 'not_produced')
                                  ? (_openBlock(), _createBlock(_component_NeueButton, {
                                      key: 0,
                                      type: "secondary",
                                      disabled: packingBottle.value[bottle.id],
                                      class: "w-full",
                                      onClick: $event => (markPacked(bottle))
                                    }, {
                                      default: _withCtx(() => [
                                        _cache[56] || (_cache[56] = _createTextVNode(" Mark as packed ", -1)),
                                        (packingBottle.value[bottle.id])
                                          ? (_openBlock(), _createBlock(_component_BasicSpinner, {
                                              key: 0,
                                              size: "small",
                                              class: "ml-2"
                                            }))
                                          : _createCommentVNode("", true)
                                      ]),
                                      _: 2
                                    }, 1032, ["disabled", "onClick"]))
                                  : _createCommentVNode("", true),
                                (canUpdateOrders.value && bottle?.attributes.production_status === 'packed')
                                  ? (_openBlock(), _createBlock(_component_NeueButton, {
                                      key: 1,
                                      type: "secondary",
                                      disabled: packingBottle.value[bottle.id],
                                      class: "w-full",
                                      onClick: $event => (markNotPacked(bottle))
                                    }, {
                                      default: _withCtx(() => [
                                        _cache[57] || (_cache[57] = _createTextVNode(" Mark not packed ", -1)),
                                        (packingBottle.value[bottle.id])
                                          ? (_openBlock(), _createBlock(_component_BasicSpinner, {
                                              key: 0,
                                              size: "small",
                                              class: "ml-2"
                                            }))
                                          : _createCommentVNode("", true)
                                      ]),
                                      _: 2
                                    }, 1032, ["disabled", "onClick"]))
                                  : _createCommentVNode("", true)
                              ])
                            ]))
                          }), 128))
                        ]),
                        _createVNode(_component_NeuePagination, {
                          size: pagination.value.arrival.size,
                          from: 1 + pagination.value.arrival.page * pageSize,
                          to: (1 + pagination.value.arrival.page) * pageSize,
                          onPrev: _cache[13] || (_cache[13] = ret => ordersPrev('Orders with arrival day', ret)),
                          onNext: _cache[14] || (_cache[14] = ret => ordersNext('Orders with arrival day', ret))
                        }, null, 8, ["size", "from", "to"])
                      ]))
                    : _createCommentVNode("", true),
                  (!arrival.value[pagination.value.arrival.page]?.length)
                    ? (_openBlock(), _createBlock(_component_NeueWell, {
                        key: 1,
                        class: "text-center"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_EmptyState, {
                            plural: "carts",
                            description: ""
                          })
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }, 8, ["loading"])
            ], 512), [
              [_vShow, ordersTab.value === 'Orders with arrival day']
            ]),
            _withDirectives(_createElementVNode("div", null, [
              _createVNode(_component_NeueLoading, {
                loading: loading.value.cancelled
              }, {
                default: _withCtx(() => [
                  (cancelled.value[pagination.value.cancelled.page]?.length)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_93, [
                        _createElementVNode("div", _hoisted_94, [
                          _createVNode(_component_NeueTablist, null, {
                            head: _withCtx(() => [
                              _createVNode(_component_TablistHeader, null, {
                                default: _withCtx(() => [
                                  _createVNode(TablistGrid, {
                                    columns: ['Cancelled orders'],
                                    header: ""
                                  }, {
                                    default: _withCtx(() => [...(_cache[58] || (_cache[58] = [
                                      _createElementVNode("div", null, "Cancelled orders", -1)
                                    ]))]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })
                            ]),
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(cancelled.value[pagination.value.cancelled.page], (bottle) => {
                                return (_openBlock(), _createBlock(_component_TablistRow, {
                                  key: bottle.id
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_unref(BottleRow), {
                                      bottle: bottle,
                                      onOrderStatusChanged: reloadAllOrderTabsExceptCurrent
                                    }, null, 8, ["bottle"])
                                  ]),
                                  _: 2
                                }, 1024))
                              }), 128))
                            ]),
                            _: 1
                          })
                        ]),
                        _createVNode(_component_NeuePagination, {
                          size: pagination.value.cancelled.size,
                          from: 1 + pagination.value.cancelled.page * pageSize,
                          to: (1 + pagination.value.cancelled.page) * pageSize,
                          onPrev: _cache[15] || (_cache[15] = ret => bottlesPrev(ordersTab.value, ret)),
                          onNext: _cache[16] || (_cache[16] = ret => bottlesNext(ordersTab.value, ret))
                        }, null, 8, ["size", "from", "to"])
                      ]))
                    : _createCommentVNode("", true),
                  (!cancelled.value[pagination.value.cancelled.page]?.length)
                    ? (_openBlock(), _createBlock(_component_NeueWell, {
                        key: 1,
                        class: "text-center"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_EmptyState, {
                            plural: "cancelled orders",
                            description: ""
                          })
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }, 8, ["loading"])
            ], 512), [
              [_vShow, ordersTab.value === 'Cancelled orders']
            ])
          ], 512), [
            [_vShow, _unref(activeTab) === 'orders']
          ]),
          (uberDeliveries.value.length)
            ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_95, [
                _createElementVNode("div", _hoisted_96, [
                  _createVNode(_component_NeueTablist, null, {
                    head: _withCtx(() => [
                      _createVNode(_component_TablistHeader, null, {
                        default: _withCtx(() => [
                          _createVNode(TablistGrid, {
                            columns: uberDeliveriesCols,
                            header: "",
                            class: "items-center"
                          }, {
                            default: _withCtx(() => [...(_cache[59] || (_cache[59] = [
                              _createElementVNode("div", null, "Order", -1),
                              _createElementVNode("div", null, "Customer", -1),
                              _createElementVNode("div", null, "Window", -1),
                              _createElementVNode("div", null, "Status", -1),
                              _createElementVNode("div", null, null, -1)
                            ]))]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(uberDeliveries.value, (delivery) => {
                        return (_openBlock(), _createBlock(_component_TablistRow, {
                          key: delivery.id
                        }, {
                          default: _withCtx(() => [
                            _createVNode(TablistGrid, {
                              columns: uberDeliveriesCols,
                              class: "items-center"
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_97, [
                                  _createVNode(_component_router_link, {
                                    to: `/order/${delivery.attributes.bottle_id}`,
                                    class: "text-gray-900 font-medium hover:underline"
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(" #" + _toDisplayString(delivery.attributes.order_display_id), 1)
                                    ]),
                                    _: 2
                                  }, 1032, ["to"])
                                ]),
                                _createElementVNode("div", _hoisted_98, [
                                  _createElementVNode("div", _hoisted_99, _toDisplayString(delivery.attributes.customer_name), 1),
                                  _createElementVNode("div", _hoisted_100, _toDisplayString(delivery.attributes.dropoff_address), 1)
                                ]),
                                _createElementVNode("div", _hoisted_101, _toDisplayString(uberDeliveryWindow(delivery)), 1),
                                _createElementVNode("div", _hoisted_102, [
                                  _createElementVNode("div", _hoisted_103, _toDisplayString(uberDeliveryStatusLabel(delivery)), 1),
                                  (delivery.attributes.courier_name)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_104, _toDisplayString(delivery.attributes.courier_name), 1))
                                    : _createCommentVNode("", true)
                                ]),
                                _createElementVNode("div", _hoisted_105, [
                                  (delivery.attributes.tracking_url)
                                    ? (_openBlock(), _createElementBlock("a", {
                                        key: 0,
                                        href: delivery.attributes.tracking_url,
                                        target: "_blank",
                                        rel: "noopener noreferrer"
                                      }, [
                                        _createVNode(_component_NeueButton, { type: "secondary" }, {
                                          default: _withCtx(() => [...(_cache[60] || (_cache[60] = [
                                            _createTextVNode("Track", -1)
                                          ]))]),
                                          _: 1
                                        })
                                      ], 8, _hoisted_106))
                                    : _createCommentVNode("", true),
                                  (delivery.attributes.cancellable && canUpdateOrders.value)
                                    ? (_openBlock(), _createBlock(_component_NeueButton, {
                                        key: 1,
                                        type: "secondary",
                                        loading: cancellingDelivery.value[delivery.id],
                                        onClick: $event => (cancelDelivery(delivery))
                                      }, {
                                        default: _withCtx(() => [...(_cache[61] || (_cache[61] = [
                                          _createTextVNode(" Cancel courier ", -1)
                                        ]))]),
                                        _: 1
                                      }, 8, ["loading", "onClick"]))
                                    : _createCommentVNode("", true)
                                ])
                              ]),
                              _: 2
                            }, 1024)
                          ]),
                          _: 2
                        }, 1024))
                      }), 128))
                    ]),
                    _: 1
                  }),
                  (deliveryError.value)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_107, _toDisplayString(deliveryError.value), 1))
                    : _createCommentVNode("", true)
                ])
              ], 512)), [
                [_vShow, _unref(activeTab) === 'uber-deliveries']
              ])
            : _createCommentVNode("", true),
          _withDirectives(_createElementVNode("div", _hoisted_108, [
            _createElementVNode("div", _hoisted_109, [
              _createElementVNode("div", _hoisted_110, [
                _createVNode(_component_SelectInput, {
                  modelValue: cartsTab.value,
                  "onUpdate:modelValue": _cache[17] || (_cache[17] = $event => ((cartsTab).value = $event)),
                  options: cartsTabs.value.map(tab => ({ name: tab, value: tab }))
                }, null, 8, ["modelValue", "options"])
              ]),
              _createElementVNode("div", _hoisted_111, [
                _createElementVNode("nav", _hoisted_112, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(cartsTabs.value, (tab) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: tab,
                      class: _normalizeClass([
                      cartsTab.value === tab ? 'bg-gray-100 text-gray-700' : 'text-gray-500 hover:text-gray-700',
                      'px-3 py-2 font-medium text-sm rounded-md cursor-pointer flex items-center mr-4'
                    ]),
                      "aria-current": cartsTab.value === tab ? 'page' : undefined,
                      onClick: $event => (cartsTab.value = tab)
                    }, [
                      _createTextVNode(_toDisplayString(tab) + " ", 1),
                      _createElementVNode("span", _hoisted_114, [
                        (
                          {
                            'Unpaid carts': detail.value?.attributes.number_of_carts || pagination.value.carts.size != null,
                            'Carts that need attention': pagination.value.attention.size != null,
                            Skipped: pagination.value.skipped.size != null,
                            'Will be charged': pagination.value.pending.size != null
                          }[tab]
                        )
                          ? (_openBlock(), _createElementBlock("span", _hoisted_115, _toDisplayString({
                            'Unpaid carts': pagination.value.carts.size ?? detail.value?.attributes.number_of_carts,
                            'Carts that need attention': pagination.value.attention.size,
                            Skipped: pagination.value.skipped.size,
                            'Will be charged': pagination.value.pending.size
                          }[tab]), 1))
                          : (_openBlock(), _createBlock(_component_BasicSpinner, {
                              key: 1,
                              size: "small"
                            }))
                      ])
                    ], 10, _hoisted_113))
                  }), 128))
                ])
              ])
            ]),
            _withDirectives(_createElementVNode("div", null, [
              _createVNode(_component_NeueLoading, {
                loading: loading.value.carts
              }, {
                default: _withCtx(() => [
                  (carts.value[pagination.value.carts.page]?.length)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_116, [
                        _createElementVNode("div", _hoisted_117, [
                          _createVNode(_component_NeueTablist, null, {
                            head: _withCtx(() => [
                              _createVNode(_component_TablistHeader, null, {
                                default: _withCtx(() => [
                                  _createVNode(TablistGrid, {
                                    columns: ['Carts'],
                                    header: ""
                                  }, {
                                    default: _withCtx(() => [...(_cache[62] || (_cache[62] = [
                                      _createElementVNode("div", null, "Carts", -1)
                                    ]))]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })
                            ]),
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(carts.value[pagination.value.carts.page], (bottle) => {
                                return (_openBlock(), _createBlock(_component_TablistRow, {
                                  key: bottle.id
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_unref(BottleRow), {
                                      bottle: bottle,
                                      lite: ""
                                    }, null, 8, ["bottle"])
                                  ]),
                                  _: 2
                                }, 1024))
                              }), 128))
                            ]),
                            _: 1
                          })
                        ]),
                        _createVNode(_component_NeuePagination, {
                          size: pagination.value.carts.size,
                          from: 1 + pagination.value.carts.page * pageSize,
                          to: (1 + pagination.value.carts.page) * pageSize,
                          onPrev: _cache[18] || (_cache[18] = ret => bottlesPrev(cartsTab.value, ret)),
                          onNext: _cache[19] || (_cache[19] = ret => bottlesNext(cartsTab.value, ret))
                        }, null, 8, ["size", "from", "to"])
                      ]))
                    : _createCommentVNode("", true),
                  (!carts.value[pagination.value.carts.page]?.length)
                    ? (_openBlock(), _createBlock(_component_NeueWell, {
                        key: 1,
                        class: "text-center"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_EmptyState, {
                            plural: "carts",
                            description: ""
                          })
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }, 8, ["loading"])
            ], 512), [
              [_vShow, cartsTab.value === 'Unpaid carts']
            ]),
            _withDirectives(_createElementVNode("div", null, [
              _createVNode(_component_NeueLoading, {
                loading: loading.value.attention
              }, {
                default: _withCtx(() => [
                  (attention.value[pagination.value.attention.page]?.length)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_118, [
                        _createElementVNode("div", _hoisted_119, [
                          _createVNode(_component_NeueTablist, null, {
                            head: _withCtx(() => [
                              _createVNode(_component_TablistHeader, null, {
                                default: _withCtx(() => [
                                  _createVNode(TablistGrid, {
                                    columns: ['Carts that need attention'],
                                    header: ""
                                  }, {
                                    default: _withCtx(() => [...(_cache[63] || (_cache[63] = [
                                      _createElementVNode("div", null, "Carts that need attention", -1)
                                    ]))]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })
                            ]),
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(attention.value[pagination.value.attention.page], (bottle) => {
                                return (_openBlock(), _createBlock(_component_TablistRow, {
                                  key: bottle.id
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_unref(BottleRow), {
                                      bottle: bottle,
                                      lite: ""
                                    }, null, 8, ["bottle"])
                                  ]),
                                  _: 2
                                }, 1024))
                              }), 128))
                            ]),
                            _: 1
                          })
                        ]),
                        _createVNode(_component_NeuePagination, {
                          size: pagination.value.attention.size,
                          from: 1 + pagination.value.attention.page * pageSize,
                          to: (1 + pagination.value.attention.page) * pageSize,
                          onPrev: _cache[20] || (_cache[20] = ret => bottlesPrev(cartsTab.value, ret)),
                          onNext: _cache[21] || (_cache[21] = ret => bottlesNext(cartsTab.value, ret))
                        }, null, 8, ["size", "from", "to"])
                      ]))
                    : _createCommentVNode("", true),
                  (!attention.value[pagination.value.attention.page]?.length)
                    ? (_openBlock(), _createBlock(_component_NeueWell, {
                        key: 1,
                        class: "text-center"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_EmptyState, {
                            plural: "carts that need attention",
                            description: ""
                          })
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }, 8, ["loading"])
            ], 512), [
              [_vShow, cartsTab.value === 'Carts that need attention']
            ]),
            _withDirectives(_createElementVNode("div", null, [
              _createVNode(_component_NeueLoading, {
                loading: loading.value.skipped
              }, {
                default: _withCtx(() => [
                  (skipped.value[pagination.value.skipped.page]?.length)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_120, [
                        _createElementVNode("div", _hoisted_121, [
                          _createVNode(_component_NeueTablist, null, {
                            head: _withCtx(() => [
                              _createVNode(_component_TablistHeader, null, {
                                default: _withCtx(() => [
                                  _createVNode(TablistGrid, {
                                    columns: ['Skipped'],
                                    header: ""
                                  }, {
                                    default: _withCtx(() => [...(_cache[64] || (_cache[64] = [
                                      _createElementVNode("div", null, "Skipped", -1)
                                    ]))]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })
                            ]),
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(skipped.value[pagination.value.skipped.page], (bottle) => {
                                return (_openBlock(), _createBlock(_component_TablistRow, {
                                  key: bottle.id
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_unref(BottleRow), { bottle: bottle }, null, 8, ["bottle"])
                                  ]),
                                  _: 2
                                }, 1024))
                              }), 128))
                            ]),
                            _: 1
                          })
                        ]),
                        _createVNode(_component_NeuePagination, {
                          size: pagination.value.skipped.size,
                          from: 1 + pagination.value.skipped.page * pageSize,
                          to: (1 + pagination.value.skipped.page) * pageSize,
                          onPrev: _cache[22] || (_cache[22] = ret => bottlesPrev(cartsTab.value, ret)),
                          onNext: _cache[23] || (_cache[23] = ret => bottlesNext(cartsTab.value, ret))
                        }, null, 8, ["size", "from", "to"])
                      ]))
                    : _createCommentVNode("", true),
                  (!skipped.value[pagination.value.skipped.page]?.length)
                    ? (_openBlock(), _createBlock(_component_NeueWell, {
                        key: 1,
                        class: "text-center"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_EmptyState, {
                            plural: "skipped carts",
                            description: ""
                          })
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }, 8, ["loading"])
            ], 512), [
              [_vShow, cartsTab.value === 'Skipped']
            ]),
            _withDirectives(_createElementVNode("div", null, [
              _createVNode(_component_NeueLoading, {
                loading: loading.value.pending
              }, {
                default: _withCtx(() => [
                  (pending.value[pagination.value.pending.page]?.length)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_122, [
                        _createElementVNode("div", _hoisted_123, [
                          _createVNode(_component_NeueTablist, null, {
                            head: _withCtx(() => [
                              _createVNode(_component_TablistHeader, null, {
                                default: _withCtx(() => [
                                  _createVNode(TablistGrid, {
                                    columns: ['Will be charged'],
                                    header: ""
                                  }, {
                                    default: _withCtx(() => [...(_cache[65] || (_cache[65] = [
                                      _createElementVNode("div", null, "Will be charged", -1)
                                    ]))]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })
                            ]),
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(pending.value[pagination.value.pending.page], (bottle) => {
                                return (_openBlock(), _createBlock(_component_TablistRow, {
                                  key: bottle.id
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_unref(BottleRow), { bottle: bottle }, null, 8, ["bottle"])
                                  ]),
                                  _: 2
                                }, 1024))
                              }), 128))
                            ]),
                            _: 1
                          })
                        ]),
                        _createVNode(_component_NeuePagination, {
                          size: pagination.value.pending.size,
                          from: 1 + pagination.value.pending.page * pageSize,
                          to: (1 + pagination.value.pending.page) * pageSize,
                          onPrev: _cache[24] || (_cache[24] = ret => bottlesPrev(cartsTab.value, ret)),
                          onNext: _cache[25] || (_cache[25] = ret => bottlesNext(cartsTab.value, ret))
                        }, null, 8, ["size", "from", "to"])
                      ]))
                    : _createCommentVNode("", true),
                  (!pending.value[pagination.value.pending.page]?.length)
                    ? (_openBlock(), _createBlock(_component_NeueWell, {
                        key: 1,
                        class: "text-center"
                      }, {
                        default: _withCtx(() => [...(_cache[66] || (_cache[66] = [
                          _createElementVNode("div", { class: "text-center" }, [
                            _createElementVNode("svg", {
                              class: "mx-auto h-12 w-12 text-gray-400",
                              fill: "none",
                              viewBox: "0 0 24 24",
                              stroke: "currentColor",
                              "aria-hidden": "true"
                            }, [
                              _createElementVNode("path", {
                                "vector-effect": "non-scaling-stroke",
                                "stroke-linecap": "round",
                                "stroke-linejoin": "round",
                                "stroke-width": "2",
                                d: "M9 13h6m-3-3v6m-9 1V7a2 2 0 012-2h6l2 2h6a2 2 0 012 2v8a2 2 0 01-2 2H5a2 2 0 01-2-2z"
                              })
                            ]),
                            _createElementVNode("h3", { class: "mt-2 text-sm font-medium text-gray-900" }, "Nobody set to be charged")
                          ], -1)
                        ]))]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }, 8, ["loading"])
            ], 512), [
              [_vShow, cartsTab.value === 'Will be charged']
            ])
          ], 512), [
            [_vShow, _unref(activeTab) === 'carts']
          ]),
          _withDirectives(_createElementVNode("div", _hoisted_124, [
            _createVNode(_component_NeueLoading, {
              loading: loading.value.products
            }, {
              default: _withCtx(() => [
                (products.value.length)
                  ? (_openBlock(), _createBlock(_component_NeueTablist, { key: 0 }, {
                      head: _withCtx(() => [
                        _createVNode(_component_TablistHeader, null, {
                          default: _withCtx(() => [
                            _createVNode(TablistGrid, {
                              columns: [{ width: '3rem' }, { width: '1fr' }, { width: '8rem' }],
                              header: ""
                            }, {
                              default: _withCtx(() => [...(_cache[67] || (_cache[67] = [
                                _createElementVNode("div", null, "Count", -1),
                                _createElementVNode("div", null, "Product", -1),
                                _createElementVNode("div", null, "Value", -1)
                              ]))]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(products.value, (product) => {
                          return (_openBlock(), _createBlock(_component_TablistRow, {
                            key: product.id,
                            class: "truncate"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(TablistGrid, { columns: [{ width: '3rem' }, { width: '1fr' }, { width: '8rem' }] }, {
                                default: _withCtx(() => [
                                  _createElementVNode("div", null, [
                                    _createElementVNode("div", null, _toDisplayString(product.attributes.quantity), 1),
                                    (!loadingVariants.value[product.id])
                                      ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(productVariants.value[product.id] || [], (variant, index) => {
                                          return (_openBlock(), _createElementBlock("div", { key: index }, [
                                            (variant.internal_sku != product.id)
                                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                                  _createTextVNode(_toDisplayString(variant.quantity), 1)
                                                ], 64))
                                              : _createCommentVNode("", true)
                                          ]))
                                        }), 128))
                                      : _createCommentVNode("", true)
                                  ]),
                                  _createElementVNode("div", _hoisted_125, [
                                    _createElementVNode("div", null, [
                                      _createVNode(_component_router_link, {
                                        to: '/store/products/' + product.id,
                                        class: "font-semibold text-gray-700"
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(product.attributes.product_name), 1)
                                        ]),
                                        _: 2
                                      }, 1032, ["to"]),
                                      (loadingVariants.value[product.id])
                                        ? (_openBlock(), _createBlock(_component_BasicSpinner, {
                                            key: 0,
                                            size: "small",
                                            class: "ml-2"
                                          }))
                                        : _createCommentVNode("", true)
                                    ]),
                                    (!loadingVariants.value[product.id])
                                      ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(productVariants.value[product.id] || [], (variant, index) => {
                                          return (_openBlock(), _createElementBlock("div", { key: index }, [
                                            (variant.internal_sku != product.id)
                                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                                  _createTextVNode(_toDisplayString(variant.variant_option_combination), 1)
                                                ], 64))
                                              : _createCommentVNode("", true)
                                          ]))
                                        }), 128))
                                      : _createCommentVNode("", true)
                                  ]),
                                  _createElementVNode("div", null, [
                                    _createElementVNode("div", null, _toDisplayString(product.attributes.price.format), 1),
                                    (!loadingVariants.value[product.id])
                                      ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(productVariants.value[product.id] || [], (variant, index) => {
                                          return (_openBlock(), _createElementBlock("div", { key: index }, [
                                            (variant.internal_sku != product.id)
                                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                                  _createTextVNode(_toDisplayString(variant.total.format), 1)
                                                ], 64))
                                              : _createCommentVNode("", true)
                                          ]))
                                        }), 128))
                                      : _createCommentVNode("", true)
                                  ])
                                ]),
                                _: 2
                              }, 1024)
                            ]),
                            _: 2
                          }, 1024))
                        }), 128))
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (!products.value.length)
                  ? (_openBlock(), _createBlock(_component_NeueWell, {
                      key: 1,
                      class: "text-center"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_EmptyState, {
                          plural: "products",
                          description: ""
                        })
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["loading"])
          ], 512), [
            [_vShow, _unref(activeTab) === 'products']
          ]),
          _withDirectives(_createElementVNode("div", _hoisted_126, [
            _createVNode(_component_NeueLoading, {
              loading: loading.value.pairs
            }, {
              default: _withCtx(() => [
                (pairs.value[pagination.value.pairs.page]?.length)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_127, [
                      _createElementVNode("div", _hoisted_128, [
                        _createVNode(_component_NeueTablist, null, {
                          head: _withCtx(() => [
                            _createVNode(_component_TablistHeader, null, {
                              default: _withCtx(() => [
                                _createVNode(TablistGrid, {
                                  columns: cartSubscribersCols,
                                  header: ""
                                }, {
                                  default: _withCtx(() => [...(_cache[68] || (_cache[68] = [
                                    _createElementVNode("div", null, "Customer", -1),
                                    _createElementVNode("div", null, "Last Message", -1),
                                    _createElementVNode("div", null, "Sent Time", -1)
                                  ]))]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(pairs.value[pagination.value.pairs.page], (pair) => {
                              return (_openBlock(), _createBlock(_component_TablistRow, {
                                key: pair.id,
                                class: "cursor-pointer",
                                onClick: $event => (_unref(router).push('/messages/' + pair.id))
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(TablistGrid, {
                                    columns: cartSubscribersCols,
                                    class: "items-center"
                                  }, {
                                    default: _withCtx(() => [
                                      _createElementVNode("div", _hoisted_129, _toDisplayString(pair.attributes.display_name), 1),
                                      _createElementVNode("div", _hoisted_130, _toDisplayString(lastMessage(pair, pagination.value.pairs.page)?.attributes.body_decoded), 1),
                                      (_openBlock(), _createElementBlock("div", { key: cachebuster.value }, _toDisplayString(relativeFormat(pair.attributes.last_sent_timestamp)), 1))
                                    ]),
                                    _: 2
                                  }, 1024)
                                ]),
                                _: 2
                              }, 1032, ["onClick"]))
                            }), 128))
                          ]),
                          _: 1
                        })
                      ]),
                      _createVNode(_component_NeuePagination, {
                        size: pagination.value.pairs.size,
                        from: 1 + pagination.value.pairs.page * pageSize,
                        to: (1 + pagination.value.pairs.page) * pageSize,
                        onPrev: pairsPrev,
                        onNext: pairsNext
                      }, null, 8, ["size", "from", "to"])
                    ]))
                  : _createCommentVNode("", true),
                (!pairs.value[pagination.value.pairs.page]?.length)
                  ? (_openBlock(), _createBlock(_component_NeueWell, {
                      key: 1,
                      class: "text-center"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_EmptyState, {
                          plural: "customers",
                          description: ""
                        })
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["loading"])
          ], 512), [
            [_vShow, _unref(activeTab) === 'customers']
          ]),
          _withDirectives(_createElementVNode("div", _hoisted_131, [
            _createVNode(_component_NeueLoading, {
              loading: loading.value.automations
            }, {
              default: _withCtx(() => [
                (automations.value?.length)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_132, [
                      _createVNode(_component_NeueTablist, null, {
                        head: _withCtx(() => [
                          _createVNode(_component_TablistHeader, null, {
                            default: _withCtx(() => [
                              _createVNode(TablistGrid, {
                                columns: automationsCols,
                                header: "",
                                class: "items-center"
                              }, {
                                default: _withCtx(() => [
                                  _cache[70] || (_cache[70] = _createElementVNode("div", null, "Scheduled Time", -1)),
                                  _cache[71] || (_cache[71] = _createElementVNode("div", null, "Lists", -1)),
                                  _cache[72] || (_cache[72] = _createElementVNode("div", null, "Drop/Automation", -1)),
                                  _createElementVNode("div", _hoisted_133, [
                                    _createVNode(_component_NeueButton, {
                                      type: "primary",
                                      disabled: !canCreateAutomations.value,
                                      class: _normalizeClass(!canCreateAutomations.value && 'opacity-50 cursor-not-allowed'),
                                      onClick: _cache[26] || (_cache[26] = $event => (
                              canCreateAutomations.value &&
                                _unref(router).push({
                                  path: '/automation/message/new',
                                  query: { list: audience.value.id, ...(isDateAudience.value && { segment: 'orders' }) }
                                })
                            ))
                                    }, {
                                      default: _withCtx(() => [...(_cache[69] || (_cache[69] = [
                                        _createTextVNode(" + Message ", -1)
                                      ]))]),
                                      _: 1
                                    }, 8, ["disabled", "class"])
                                  ])
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(automations.value, (automation) => {
                            return (_openBlock(), _createBlock(_component_TablistRow, {
                              key: `${automation.type}-${automation.id}`
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_router_link, {
                                  to: automationLink(automation),
                                  class: "w-full cursor-pointer"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(TablistGrid, { columns: automationsCols }, {
                                      default: _withCtx(() => [
                                        (_openBlock(), _createElementBlock("div", {
                                          key: cachebuster.value,
                                          class: "text-gray-900 font-medium truncate"
                                        }, _toDisplayString(`${relativeFormat(automationTime(automation))} (${absoluteFormat(automationTime(automation))})`), 1)),
                                        _createElementVNode("div", _hoisted_134, [
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(automationAudiences(automation), (aud, i) => {
                                            return (_openBlock(), _createElementBlock("span", {
                                              key: aud.id
                                            }, _toDisplayString(aud.attributes.audience_name +
                              (i !== automationAudiences(automation).length - 1 ? ', ' : '')), 1))
                                          }), 128))
                                        ]),
                                        _createElementVNode("div", _hoisted_135, _toDisplayString(automationDrop(automation)?.attributes.description || automation.attributes.name), 1),
                                        _cache[73] || (_cache[73] = _createElementVNode("div", null, null, -1))
                                      ]),
                                      _: 2
                                    }, 1024)
                                  ]),
                                  _: 2
                                }, 1032, ["to"])
                              ]),
                              _: 2
                            }, 1024))
                          }), 128))
                        ]),
                        _: 1
                      })
                    ]))
                  : _createCommentVNode("", true),
                (!automations.value?.length)
                  ? (_openBlock(), _createBlock(_component_NeueWell, { key: 1 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_EmptyState, { plural: "upcoming automations" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_NeueButton, {
                              type: "primary",
                              disabled: !canCreateAutomations.value,
                              class: _normalizeClass(!canCreateAutomations.value && 'opacity-50 cursor-not-allowed'),
                              onClick: _cache[27] || (_cache[27] = $event => (
                      canCreateAutomations.value &&
                        _unref(router).push({
                          path: '/automation/message/new',
                          query: { list: audience.value.id, ...(isDateAudience.value && { segment: 'orders' }) }
                        })
                    ))
                            }, {
                              default: _withCtx(() => [...(_cache[74] || (_cache[74] = [
                                _createTextVNode(" + Message ", -1)
                              ]))]),
                              _: 1
                            }, 8, ["disabled", "class"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["loading"])
          ], 512), [
            [_vShow, _unref(activeTab) === 'automations']
          ]),
          (!hideNumbers.value)
            ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_136, [
                _createVNode(_component_NeueLoading, {
                  loading: loading.value.reports
                }, {
                  default: _withCtx(() => [
                    (reports.value?.length)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_137, [
                          _createVNode(_component_NeueTablist, null, {
                            head: _withCtx(() => [
                              _createVNode(_component_TablistHeader, null, {
                                default: _withCtx(() => [
                                  _createVNode(TablistGrid, {
                                    columns: reportsCols,
                                    header: "",
                                    class: "items-center"
                                  }, {
                                    default: _withCtx(() => [
                                      _cache[76] || (_cache[76] = _createElementVNode("div", null, "Time Created", -1)),
                                      _cache[77] || (_cache[77] = _createElementVNode("div", null, "Description", -1)),
                                      _cache[78] || (_cache[78] = _createElementVNode("div", null, "Emailed To", -1)),
                                      _createElementVNode("div", _hoisted_138, [
                                        _createVNode(_component_NeueButton, {
                                          type: "primary",
                                          disabled: !canCreateReports.value,
                                          class: _normalizeClass(!canCreateReports.value && 'opacity-50 cursor-not-allowed'),
                                          onClick: _cache[28] || (_cache[28] = $event => (canCreateReports.value && (reportsModalOpen.value = true)))
                                        }, {
                                          default: _withCtx(() => [...(_cache[75] || (_cache[75] = [
                                            _createTextVNode(" + Report ", -1)
                                          ]))]),
                                          _: 1
                                        }, 8, ["disabled", "class"])
                                      ])
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })
                            ]),
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(reports.value, (report) => {
                                return (_openBlock(), _createBlock(_component_TablistRow, {
                                  key: report.id
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(TablistGrid, {
                                      columns: reportsCols,
                                      class: "items-center"
                                    }, {
                                      default: _withCtx(() => [
                                        _createElementVNode("div", _hoisted_139, _toDisplayString(absoluteFormat(report.attributes.created_at)), 1),
                                        _createElementVNode("div", _hoisted_140, _toDisplayString(report.attributes.display_name), 1),
                                        _createElementVNode("div", _hoisted_141, [
                                          (report.attributes.email)
                                            ? (_openBlock(), _createElementBlock("span", _hoisted_142, _toDisplayString(report.attributes.email), 1))
                                            : (_openBlock(), _createElementBlock("span", _hoisted_143, "No email"))
                                        ]),
                                        _createElementVNode("div", _hoisted_144, [
                                          (report.attributes.is_expired)
                                            ? (_openBlock(), _createElementBlock("span", _hoisted_145, "Expired"))
                                            : (report.attributes.link_to_report)
                                              ? (_openBlock(), _createElementBlock("a", {
                                                  key: 1,
                                                  href: report.attributes.link_to_report,
                                                  class: "flex items-center",
                                                  target: "_blank"
                                                }, [
                                                  _cache[79] || (_cache[79] = _createTextVNode(" Download ", -1)),
                                                  _createVNode(_unref(ArrowDownTrayIcon), { class: "ml-2 h-5 w-5 inline" })
                                                ], 8, _hoisted_146))
                                              : (_openBlock(), _createBlock(_component_BasicSpinner, { key: 2 }))
                                        ])
                                      ]),
                                      _: 2
                                    }, 1024)
                                  ]),
                                  _: 2
                                }, 1024))
                              }), 128))
                            ]),
                            _: 1
                          })
                        ]))
                      : _createCommentVNode("", true),
                    (!reports.value?.length)
                      ? (_openBlock(), _createBlock(_component_NeueWell, { key: 1 }, {
                          default: _withCtx(() => [
                            _createVNode(_component_EmptyState, { plural: "downloaded reports yet" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_NeueButton, {
                                  type: "primary",
                                  disabled: !canCreateReports.value,
                                  class: _normalizeClass(!canCreateReports.value && 'opacity-50 cursor-not-allowed'),
                                  onClick: _cache[29] || (_cache[29] = $event => (canCreateReports.value && (reportsModalOpen.value = true)))
                                }, {
                                  default: _withCtx(() => [...(_cache[80] || (_cache[80] = [
                                    _createTextVNode(" + Report ", -1)
                                  ]))]),
                                  _: 1
                                }, 8, ["disabled", "class"])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }, 8, ["loading"])
              ], 512)), [
                [_vShow, _unref(activeTab) === 'reports']
              ])
            : _createCommentVNode("", true)
        ]),
        (!__props.leadTab && !audience.value?.attributes.created_by_bottle)
          ? (_openBlock(), _createBlock(_component_PageFooter, { key: 0 }, {
              left: _withCtx(() => [
                _createVNode(_component_NeueButton, {
                  type: "red",
                  onClick: _cache[30] || (_cache[30] = $event => (deleteModal.value.open = true))
                }, {
                  default: _withCtx(() => [...(_cache[81] || (_cache[81] = [
                    _createTextVNode("Delete list", -1)
                  ]))]),
                  _: 1
                })
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 3
  }))
}
}

}